/* ===== from <script> block in dba-brand-styles.liquid (rendered only when template != 'index') ===== */

(function(){
  'use strict';
  if (window.__dbaPdpEnhanced) return;
  window.__dbaPdpEnhanced = true;

  function init(){
    try { applyEnhancements(); } catch (e) { console.warn('[DBA] enhance failed', e); }
    // re-run after navigation / view-transitions
    document.addEventListener('shopify:section:load', applyEnhancements, {passive:true});
    document.addEventListener('page:loaded', applyEnhancements, {passive:true});
  }

  function applyEnhancements(){
    fixTitleTm();
    upgradeLaunchKit();
    insertHotline();
    insertDuduTestimonial();
    insertTestimonials();
    // Per Jesse v33: keep the multi-tab competitor comparison; mobile uses the stacked-card layout from v31
    insertComparisonV2();
    insertFAQ45();
    speedUpStatsCounters();
    convertFiveReasonsToSlideshow();
    enableKitFlipCards();
    addRecipeSwitcher();
    insertManusVideoSection();
    rewriteMathCta();
    insertPostLooxCTA();
    swapProduct360Gifs();
    seeHowItWorksScroll();
    rewriteNavAndSocialLinks();
    fixHotlineCopy();
    // Per Jesse v24: keep SureDough™ trademark in footer (was fixSureDoughTrademarkInFooter)
    rewriteInstructionManualLink();
    hideOurStoryFooter();
    addFounderSignature();
    purgeOldSignatureArtifacts();
    // v43: addFooterExtraColumns() removed — was duplicating the theme's footer.
    // Theme footer is the canonical one; we add to it via augmentThemeFooter() instead.
    augmentThemeFooter();
    insertStickyAtc();
    insertTwoOfferComparison();
    restructureFounderStory();
    rewriteRecipeAppLinks();
    insertMatrixSection();
    autoInjectInstallmentText();
  }

  // ---------- TWO-OFFER COMPARISON ON PDP (Complete Kit + Mega Value Pack) ----------
  // Toggle: set window.dbaShowMegaValuePack = false to hide the Mega Value Pack offer
  // and revert to the original single buy box. Default is true.
  function insertTwoOfferComparison(){
    // Only run on PDP for the Complete Kit
    if (!/\/products\/dbakeraid-complete-kit/i.test(location.pathname)) return;
    if (document.querySelector('#dba-two-offers')) return;

    // If toggle is explicitly false, skip injection (original buy box stays visible)
    if (window.dbaShowMegaValuePack === false) return;

    // Find original buy area: from <product-price> through </product-form-component>
    var priceEl = document.querySelector('product-price');
    var formEl = document.querySelector('product-form-component');
    if (!priceEl || !formEl) return;

    function findShared(a, b){
      var anc = new Set();
      var n = a; while(n){ anc.add(n); n = n.parentElement; }
      n = b; while(n){ if(anc.has(n)) return n; n = n.parentElement; }
      return null;
    }
    function topChildContaining(parent, descendant){
      var n = descendant;
      while (n && n.parentElement !== parent) n = n.parentElement;
      return n;
    }
    var shared = findShared(priceEl, formEl);
    if (!shared) return;
    var startNode = topChildContaining(shared, priceEl);
    var endNode = topChildContaining(shared, formEl);
    if (!startNode || !endNode) return;

    // Hide every child between startNode and endNode (inclusive)
    var hiding = false;
    Array.from(shared.children).forEach(function(child){
      if (child === startNode) hiding = true;
      if (hiding) {
        child.style.display = 'none';
        child.setAttribute('data-dba-orig-buy', '1');
      }
      if (child === endNode) hiding = false;
    });

    // Build the two-offer block
    var block = document.createElement('div');
    block.className = 'dba-offers';
    block.id = 'dba-two-offers';
    block.innerHTML =
      '<div class="dba-offers__head">' +
        '<span class="dba-offers__eyebrow">Choose your bundle</span>' +
        '<h2 class="dba-offers__h">Two ways to bring D’BakerAid <em>home.</em></h2>' +
      '</div>' +
      '<div class="dba-offers__grid">' +
        // Complete Kit (Most Popular)
        '<article class="dba-offer dba-offer--popular">' +
          '<span class="dba-offer__badge">★ Most Popular</span>' +
          '<div class="dba-offer__image">' +
            '<img src="https://cdn.shopify.com/s/files/1/0721/5287/5164/files/edited_product_image_v2.png?v=1778419458" alt="D’BakerAid Complete Kit">' +
          '</div>' +
          '<div class="dba-offer__body">' +
            '<div class="dba-offer__eyebrow">The Baker’s Launch Kit · 7 items</div>' +
            '<h3 class="dba-offer__title">Complete Kit</h3>' +
            '<p class="dba-offer__tagline">Everything most bakers need to start making bakery-quality bread at home.</p>' +
            '<div class="dba-offer__price-block">' +
              '<span class="dba-offer__price">$299.95</span>' +
              '<span class="dba-offer__price-sub">free US shipping</span>' +
            '</div>' +
            '<details class="dba-offer__savings-details">' +
              '<summary>See what you get for $299.95</summary>' +
              '<div class="dba-offer__savings-body">' +
                '<table>' +
                  '<tr><td>Smart Hub + SureDough™ System</td><td>$279</td></tr>' +
                  '<tr><td>D’Steamer™ Oven Humidifier</td><td>$49</td></tr>' +
                  '<tr><td>2× Tritan Proofing Bowls + Lids</td><td>$38</td></tr>' +
                  '<tr><td>Stainless Steel Bowl</td><td>$22</td></tr>' +
                  '<tr><td>Bread Lame + 5 Extra Blades</td><td>$15</td></tr>' +
                  '<tr><td>Danish Whisk</td><td>$18</td></tr>' +
                  '<tr><td>2× Baker’s Aprons</td><td>$25</td></tr>' +
                  '<tr><td>Total retail value</td><td>$446</td></tr>' +
                  '<tr><td>Bundle price</td><td>$299.95</td></tr>' +
                  '<tr><td>You save</td><td>$146</td></tr>' +
                '</table>' +
              '</div>' +
            '</details>' +
            '<div class="dba-offer__divider"></div>' +
            '<div class="dba-offer__includes-h">What’s included</div>' +
            '<ul class="dba-offer__includes">' +
              '<li>Smart Hub + SureDough™ System</li>' +
              '<li>D’Steamer™ Oven Humidifier</li>' +
              '<li>2× Tritan Proofing Bowls + Lids</li>' +
              '<li>Stainless Steel Bowl</li>' +
              '<li>Bread Lame + 5 Extra Blades</li>' +
              '<li>Danish Whisk</li>' +
              '<li>2× Baker’s Aprons</li>' +
              '<li>2-year warranty</li>' +
            '</ul>' +
            // Installment messaging — 4-interest-free + Shop Pay branded mark
            '<div class="dba-installment">' +
              '<div class="dba-installment__row">' +
                '<div class="dba-installment__label">or <strong>4 interest-free payments of $74.99</strong></div>' +
                '<span class="dba-installment__sp"></span>' +
              '</div>' +
              '<div class="dba-installment__sub">Or as low as <strong>$28/mo</strong> over 12 months at 0–35.99% APR. Real rate shown at checkout.</div>' +
            '</div>' +
            '<div class="dba-offer__cta-wrap">' +
              '<a href="/cart/add?id=__VAR_COMPLETE__&quantity=1" data-dba-add="complete" class="dba-offer__cta">Add to cart</a>' +
              '<button type="button" class="dba-shoppay-button" data-dba-shoppay="complete">Buy with <span class="dba-sp-logo"></span></button>' +
              '<div class="dba-offer__reassure">' +
                '<span class="dba-offer__reassure-item">30-day refund</span>' +
                '<span class="dba-offer__reassure-item">Ships in 2 days</span>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</article>' +
        // Mega Value Pack (Upgrade)
        '<article class="dba-offer dba-offer--upgrade">' +
          '<span class="dba-offer__badge">Save $275.90</span>' +
          '<div class="dba-offer__image">' +
            '<img src="https://cdn.shopify.com/s/files/1/0721/5287/5164/files/Generated_Image_May_10_2026_-_8_56PM_309b18fc-d635-4202-900b-f600f082ca3d.jpg?v=1778418456" alt="D’BakerAid Mega Value Pack">' +
          '</div>' +
          '<div class="dba-offer__body">' +
            '<div class="dba-offer__eyebrow">Everything + bonuses</div>' +
            '<h3 class="dba-offer__title">Mega Value Pack</h3>' +
            '<p class="dba-offer__tagline">For bakers who’ll bake every week. Adds an artisan baking pan, 2× Pullman loaf pans, and a 3-year warranty (vs. 2-year).</p>' +
            '<div class="dba-offer__price-block">' +
              '<span class="dba-offer__price">$399.95</span>' +
              '<span class="dba-offer__price-sub">free US shipping</span>' +
            '</div>' +
            '<details class="dba-offer__savings-details">' +
              '<summary>See savings breakdown</summary>' +
              '<div class="dba-offer__savings-body">' +
                '<table>' +
                  '<tr><td>Smart Hub + SureDough™ System</td><td>$279</td></tr>' +
                  '<tr><td>D’Steamer™ Oven Humidifier</td><td>$49</td></tr>' +
                  '<tr><td>2× Tritan Proofing Bowls + Lids</td><td>$38</td></tr>' +
                  '<tr><td>Stainless Steel Bowl</td><td>$22</td></tr>' +
                  '<tr><td>Bread Lame + 5 Extra Blades</td><td>$15</td></tr>' +
                  '<tr><td>Danish Whisk</td><td>$18</td></tr>' +
                  '<tr><td>2× Baker’s Aprons</td><td>$25</td></tr>' +
                  '<tr><td>2× Pullman Loaf Pans (Ceramic)</td><td>$59.95</td></tr>' +
                  '<tr><td>Artisan Cast Iron Bread Pot (7qt)</td><td>$129.95</td></tr>' +
                  '<tr><td>3-year warranty (vs. 2-year)</td><td>$39.95</td></tr>' +
                  '<tr><td>Total retail value</td><td>$675.85</td></tr>' +
                  '<tr><td>Bundle price</td><td>$399.95</td></tr>' +
                  '<tr><td>You save</td><td>$275.90</td></tr>' +
                '</table>' +
              '</div>' +
            '</details>' +
            '<div class="dba-offer__divider"></div>' +
            '<div class="dba-offer__includes-h">Everything above · plus</div>' +
            '<ul class="dba-offer__includes">' +
              '<li class="is-bonus">2× Pullman Loaf Pans (Ceramic Coating)</li>' +
              '<li class="is-bonus">Artisan Cast Iron Bread Pot (7qt, enamel)</li>' +
              '<li class="is-bonus">3-year warranty (vs 2)</li>' +
              '<li class="is-bonus">Priority support</li>' +
            '</ul>' +
            // Installment messaging — 4-interest-free + Shop Pay branded mark
            '<div class="dba-installment">' +
              '<div class="dba-installment__row">' +
                '<div class="dba-installment__label">or <strong>4 interest-free payments of $99.99</strong></div>' +
                '<span class="dba-installment__sp"></span>' +
              '</div>' +
              '<div class="dba-installment__sub">Or as low as <strong>$37/mo</strong> over 12 months at 0–35.99% APR. Real rate shown at checkout.</div>' +
            '</div>' +
            '<div class="dba-offer__cta-wrap">' +
              '<a href="/cart/46190182400156:1" data-dba-checkout="megavalue" data-dba-variant="46190182400156" class="dba-offer__cta">Choose Mega Value — $399.95</a>' +
              '<button type="button" class="dba-shoppay-button" data-dba-shoppay="megavalue" data-dba-variant="46190182400156">Buy with <span class="dba-sp-logo"></span></button>' +
              '<div class="dba-offer__reassure">' +
                '<span class="dba-offer__reassure-item">30-day refund</span>' +
                '<span class="dba-offer__reassure-item">3-year warranty</span>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</article>' +
      '</div>';

    // Insert before the original buy area
    startNode.parentNode.insertBefore(block, startNode);

    // Wire the Complete Kit "Add to cart" to the original ATC button so all variant logic runs
    var completeBtn = block.querySelector('[data-dba-add="complete"]');
    if (completeBtn) {
      completeBtn.addEventListener('click', function(e){
        e.preventDefault();
        var realBtn = document.querySelector('.add-to-cart-button, product-form-component button[type="submit"], form[action*="/cart/add"] button[type="submit"]');
        if (realBtn) realBtn.click();
        else window.location.href = '/cart/add?id=8742725157020&quantity=1'; // fallback
      });
    }

    // Wire the Mega Value Pack "Choose Mega Value" → POST add-to-cart, then redirect straight to /checkout
    var mvpBtn = block.querySelector('[data-dba-checkout="megavalue"]');
    if (mvpBtn) {
      mvpBtn.addEventListener('click', function(e){
        e.preventDefault();
        var variantId = mvpBtn.getAttribute('data-dba-variant');
        // Disable button + show loading state
        var origText = mvpBtn.textContent;
        mvpBtn.style.pointerEvents = 'none';
        mvpBtn.style.opacity = '0.7';
        mvpBtn.textContent = 'Loading checkout…';
        // Add the Mega Value Pack to cart, then redirect to checkout
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
        })
        .then(function(r){
          if (!r.ok) throw new Error('add failed');
          window.location.href = '/checkout';
        })
        .catch(function(){
          // Fallback: cart-permalink route — still adds the variant + lands on cart, user clicks checkout
          window.location.href = '/cart/' + variantId + ':1';
        });
      });
    }

    // v46: Wire Shop Pay buttons — Complete Kit triggers the real Shopify <shopify-payment-button>;
    // MVP POSTs add-to-cart then sends the user to /checkout (Shop Pay surfaces there for returning users).
    var spComplete = block.querySelector('[data-dba-shoppay="complete"]');
    if (spComplete) {
      spComplete.addEventListener('click', function(e){
        e.preventDefault();
        var realSp = document.querySelector('shopify-payment-button button, .shopify-payment-button__button, shop-pay-button');
        if (realSp) {
          realSp.click();
        } else {
          // Fallback: trigger the real ATC then go to checkout
          var atc = document.querySelector('.add-to-cart-button, product-form-component button[type="submit"]');
          if (atc) atc.click();
          setTimeout(function(){ window.location.href = '/checkout'; }, 600);
        }
      });
    }
    var spMvp = block.querySelector('[data-dba-shoppay="megavalue"]');
    if (spMvp) {
      spMvp.addEventListener('click', function(e){
        e.preventDefault();
        var variantId = spMvp.getAttribute('data-dba-variant');
        spMvp.style.pointerEvents = 'none';spMvp.style.opacity = '0.7';
        var origLabel = spMvp.innerHTML;
        spMvp.textContent = 'Loading checkout…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
        })
        .then(function(r){
          if (!r.ok) throw new Error('add failed');
          window.location.href = '/checkout';
        })
        .catch(function(){ window.location.href = '/cart/' + variantId + ':1'; });
      });
    }
  }

  // ---------- FOUNDER STORY (about-us page) — restructure into chapters ----------
  function restructureFounderStory(){
    if (document.querySelector('.dba-story')) return;
    // Find the body paragraph in the about-founder section
    var bodyP = document.querySelector('[class*="about-founder-"][class*="__body"]');
    if (!bodyP) return;
    var raw = (bodyP.textContent || '').trim();
    if (raw.length < 500) return; // not enough content to restructure

    // Split into paragraphs by blank lines
    var paras = raw.split(/\n\s*\n+/).map(function(s){return s.trim();}).filter(Boolean);
    if (paras.length < 4) return;

    // Map paragraphs to chapters using semantic markers
    // v40: Chapter eyebrows ("Chapter 01 · Origins" etc.) removed per Jesse — just headings + body
    var chapters = [
      { heading:'Bread that humbled me.',                                       paras:[] },
      { heading:'Why does the same recipe behave differently?',                 paras:[] },
      { heading:'Engineered like a product, not a guess.',                      paras:[] },
      { heading:'It was never the recipe. It was the room.',                    paras:[], pullquote:true },
      { heading:'D’BakerAid™ — the system that controls the conditions.',       paras:[] },
      { mission:true }
    ];
    // Distribute paragraphs to chapters
    // Heuristic mapping based on content keywords
    var assigned = new Set();
    paras.forEach(function(p, idx){
      var t = p.toLowerCase();
      if (assigned.has(idx)) return;
      if (/grew up|dad|cooking always|humbled/.test(t)) {
        chapters[0].paras.push(p); assigned.add(idx);
      } else if (/covid|inconsistent|same ingredients|control over the scientific/.test(t)) {
        chapters[1].paras.push(p); assigned.add(idx);
      } else if (/product developer|engineering|food scientists|research|testing/.test(t)) {
        chapters[2].paras.push(p); assigned.add(idx);
      } else if (/conclusion became clear|environment in which/.test(t) || /great bread is not only/.test(t)) {
        chapters[3].paras.push(p); assigned.add(idx);
      } else if (/realization became|developed d’bakeraid|developed d.bakeraid|science-backed fermentation/.test(t)) {
        chapters[4].paras.push(p); assigned.add(idx);
      } else if (/our mission|professional-level fermentation control|broader vision/.test(t)) {
        chapters[5].mission = chapters[5].mission || true;
        chapters[5].paras = chapters[5].paras || [];
        chapters[5].paras.push(p); assigned.add(idx);
      }
    });
    // Any leftover paragraphs go to the last non-mission chapter (Chapter 5 build)
    paras.forEach(function(p, idx){
      if (assigned.has(idx)) return;
      chapters[4].paras.push(p);
    });

    // Build the new structure
    var wrap = document.createElement('div');
    wrap.className = 'dba-story';
    chapters.forEach(function(c){
      if (c.mission) {
        if (!c.paras || !c.paras.length) return;
        var m = document.createElement('div');
        m.className = 'dba-story__mission';
        m.innerHTML =
          '<span class="dba-story__mission-eyebrow">Our Mission</span>' +
          '<div class="dba-story__mission-text">' +
            c.paras.map(function(p){return p;}).join(' ') +
          '</div>';
        wrap.appendChild(m);
      } else if (c.paras && c.paras.length) {
        var ch = document.createElement('div');
        ch.className = 'dba-story__chapter';
        var bodyHtml = c.paras.map(function(p){
          if (c.pullquote) {
            return '<blockquote class="dba-story__pullquote">' + escapeHtml(p) + '</blockquote>';
          }
          return '<p>' + escapeHtml(p) + '</p>';
        }).join('');
        // v40: chapter eyebrows removed per Jesse — keep heading + body only
        ch.innerHTML =
          (c.eyebrow ? '<span class="dba-story__chapter-eyebrow">' + c.eyebrow + '</span>' : '') +
          '<h3 class="dba-story__chapter-h">' + c.heading + '</h3>' +
          '<div class="dba-story__chapter-body">' + bodyHtml + '</div>';
        wrap.appendChild(ch);
      }
    });

    bodyP.replaceWith(wrap);
  }
  function escapeHtml(s){
    return String(s)
      .replace(/&/g,'&amp;')
      .replace(/</g,'&lt;')
      .replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;')
      .replace(/'/g,'&#39;');
  }

  // ---------- Recipe-app link rewrites: update from base44 sandbox to dbakeraid.app ----------
  // ---------- v46/v48: Auto-inject "or 4 payments of $X" line under any CTA button that mentions a price ----------
  function autoInjectInstallmentText(){
    // v48: REMOVED .dba-hero__cta--* selectors — height-constrained hero slideshow can't take the extra line
    var ctaSelectors = [
      '.dba-six__cta', '.dba-cta-primary',
      'a.btn-liquid', '.dba-six-math__cta',
      '.dba-cmp__cta', '.dba-numbers__cta',
      '.dba-post-loox-cta__btn'
    ];
    document.querySelectorAll(ctaSelectors.join(',')).forEach(function(btn){
      if (btn.dataset.dbaInstallmentDone) return;
      // Skip if we're inside an offer card (those already have the full installment block)
      if (btn.closest('.dba-offer')) return;
      // Skip if we're inside a comparison strip (already has the line)
      if (btn.closest('.dba-cmpv2__cta-strip')) return;
      // v48: defense in depth
      if (btn.closest('.dba-hero')) return;
      // Find a price ($XX.XX) in the button text or in the parent container
      var inText = (btn.textContent || '').match(/\$\s*([\d,]+(?:\.\d+)?)/);
      var amt = null;
      if (inText) {
        amt = parseFloat(inText[1].replace(/,/g, ''));
      } else {
        // Look in the parent container for a price element
        var parent = btn.closest('section, .shopify-section, div');
        if (parent) {
          var siblingPrice = parent.querySelector('.dba-hero__price, .dba-six-math__price, [class*="__price"]');
          if (siblingPrice) {
            var m = (siblingPrice.textContent || '').match(/\$\s*([\d,]+(?:\.\d+)?)/);
            if (m) amt = parseFloat(m[1].replace(/,/g, ''));
          }
        }
      }
      if (!amt || amt < 50) return; // Shop Pay Installments only kicks in at $50+
      btn.dataset.dbaInstallmentDone = '1';
      // Detect dark vs light context
      var bgEl = btn.closest('section, .shopify-section');
      var darkParent = false;
      if (bgEl) {
        var bg = window.getComputedStyle(bgEl).backgroundColor;
        // Crude: parse rgb() and check luminance
        var rgb = bg.match(/\d+/g);
        if (rgb && rgb.length >= 3) {
          var lum = (parseInt(rgb[0]) * 299 + parseInt(rgb[1]) * 587 + parseInt(rgb[2]) * 114) / 1000;
          if (lum < 80) darkParent = true;
        }
      }
      var perPay = (amt / 4).toFixed(2);
      var note = document.createElement('div');
      note.className = 'dba-installment-text' + (darkParent ? ' dba-installment-text--on-dark' : '');
      note.style.justifyContent = 'center';
      note.style.marginTop = '10px';
      note.innerHTML = 'or <strong>4 payments of $' + perPay + '</strong> — interest-free with <span class="dba-installment-text__sp"></span>';
      // Insert AFTER the button
      if (btn.parentNode) btn.parentNode.insertBefore(note, btn.nextSibling);
    });
  }

  function rewriteRecipeAppLinks(){
    document.querySelectorAll('a').forEach(function(a){
      var href = a.getAttribute('href') || '';
      // Old: https://dbakeraidapp.base44.app/Recipes -> new: https://dbakeraid.app/Recipes
      // Old: https://dbakeraidapp.base44.app/Tools?tool=converter -> new: https://dbakeraid.app/Tools?tool=converter
      if (/dbakeraidapp\.base44\.app/i.test(href)) {
        var updated = href.replace(/https?:\/\/dbakeraidapp\.base44\.app/i, 'https://dbakeraid.app');
        a.setAttribute('href', updated);
      }
      // Also catch by visible text in case href is missing
      var t = (a.textContent || '').trim().toLowerCase();
      if (t === 'more recipes' && !/dbakeraid\.app\/Recipes/i.test(a.getAttribute('href') || '')) {
        a.setAttribute('href', 'https://dbakeraid.app/Recipes');
      }
      if (t === 'any recipe converter' && !/dbakeraid\.app\/Tools/i.test(a.getAttribute('href') || '')) {
        a.setAttribute('href', 'https://dbakeraid.app/Tools?tool=converter');
      }
    });
  }

  // ---------- v44: Augment the THEME'S footer — Efficiency + Science Backed Data ONLY in SUPPORT column ----------
  function augmentThemeFooter(){
    // Hide any leftover dba-footer-extra (the duplicate light parchment footer from v23) just in case
    document.querySelectorAll('.dba-footer-extra').forEach(function(el){ el.style.display = 'none'; });

    var cols = document.querySelectorAll('footer .dba-col, footer [class*="dba-col"]');
    cols.forEach(function(col){
      var heading = col.querySelector('h3, h4, h5, [class*="heading"]');
      if (!heading) return;
      var name = (heading.textContent || '').trim().toLowerCase();
      var ul = col.querySelector('ul, ol');
      if (!ul) return;

      // SUPPORT column: add Efficiency + Science Backed Data
      if (name === 'support') {
        if (!ul.querySelector('a[href*="/pages/efficiency"]')) {
          var li = document.createElement('li');
          li.innerHTML = '<a href="/pages/efficiency">Efficiency</a>';
          ul.appendChild(li);
        }
        if (!ul.querySelector('a[href*="/pages/the-science"]')) {
          var li2 = document.createElement('li');
          li2.innerHTML = '<a href="/pages/the-science-behind-dbakeraid">Science Backed Data</a>';
          ul.appendChild(li2);
        }
      }

      // RECIPE GUIDES, COMPANY, BAKE BETTER: clean out any prior v43 injections
      if (name === 'recipe guides' || name === 'company' || name === 'bake better') {
        Array.from(ul.querySelectorAll('a')).forEach(function(a){
          var href = a.getAttribute('href') || '';
          if (/\/pages\/efficiency/.test(href) || /\/pages\/the-science/.test(href)) {
            var li = a.closest('li');
            if (li) li.remove();
            else a.remove();
          }
        });
      }
    });
  }

  // ---------- About-us page: append D'MATRIX parent-company block at bottom ----------
  function insertMatrixSection(){
    // Only on about-us / our-story / about page templates
    if (!/\/pages\/(about|our-story)/i.test(location.pathname)) return;
    if (document.querySelector('.dba-matrix')) return;

    // Find a good anchor — last shopify-section in <main>
    var main = document.querySelector('main, #MainContent, .content-for-layout');
    if (!main) return;
    var sections = main.querySelectorAll('.shopify-section');
    var anchor = sections.length ? sections[sections.length - 1] : null;

    var block = document.createElement('section');
    block.className = 'dba-matrix';
    block.setAttribute('aria-label', 'Parent company — Matrix Tech Development');
    block.innerHTML =
      '<div class="dba-matrix__eyebrow">Our parent company</div>' +
      '<div class="dba-matrix__logo">' +
        '<img class="dba-matrix__logo-img" src="https://cdn.shopify.com/s/files/1/0721/5287/5164/files/dmatrix-logo-transparent.png?v=1778425254" alt="D’MATRIX — Backed by Science">' +
      '</div>' +
      '<div class="dba-matrix__legal">Matrix Tech Development S.L.U.</div>' +
      '<div class="dba-matrix__divider"></div>' +
      '<p class="dba-matrix__body">' +
        'As a <strong>pioneer and world-first, science-backed product development company</strong>, we commit to building a new standard in home technology: ' +
        'health-first innovation designed by measurable scientific principles — not marketing trends. ' +
        'We engineer products to be reliable, accessible, and affordable, with real, meaningful impact on everyday wellbeing.' +
      '</p>';

    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(block, anchor.nextSibling);
    } else {
      main.appendChild(block);
    }
  }

  // PDP sticky add-to-cart bar — appears when the user scrolls past the main buy buttons
  function insertStickyAtc(){
    if (document.querySelector('.dba-sticky-atc')) return;
    // Only on product pages (we're already inside template != 'index', but double-check)
    if (!document.querySelector('product-form-component, [data-product-form], form[action*="/cart/add"], .add-to-cart-button')) return;

    // Pull the product title from the page
    var titleEl = document.querySelector('.dba-pdp-title, h1.product-title, h1[class*="product"], main h1');
    var title = titleEl ? (titleEl.textContent || '').trim().replace(/\s+/g, ' ') : 'D’BakerAid SureDough Complete Kit';

    // Pull the price (Horizon's price-component renders <variant-price> with money inside)
    var priceText = '';
    var priceEl =
      document.querySelector('variant-price .price, .price__price, .price__regular, [data-price-output], .product-price, .price-item--regular, .price');
    if (priceEl) priceText = (priceEl.textContent || '').trim().replace(/\s+/g, ' ');
    if (!priceText) priceText = '$299.95';

    // Product image — fall back to the smart-scale GIF
    var imgUrl = 'https://cdn.shopify.com/s/files/1/0721/5287/5164/files/dbakeraid2_animated.gif?v=1778332470';
    var galleryImg = document.querySelector('.product-media-gallery img, [class*="product-media"] img, .media-gallery img');
    if (galleryImg) {
      var src = galleryImg.getAttribute('src') || galleryImg.getAttribute('data-src') || '';
      if (src && src.indexOf('logo') === -1) imgUrl = src;
    }

    var bar = document.createElement('div');
    bar.className = 'dba-sticky-atc';
    bar.setAttribute('aria-label', 'Sticky add to cart');
    // v49: REVERTED — sticky bar shows only price + ATC button (no installment text).
    // Keeps the bar at single-line height; financing pitch lives on the offer cards + checkout.

    bar.innerHTML =
      '<div class="dba-sticky-atc__inner">' +
        '<img class="dba-sticky-atc__img" src="' + imgUrl + '" alt="" loading="lazy">' +
        '<div class="dba-sticky-atc__meta">' +
          '<div class="dba-sticky-atc__title">' + title + '</div>' +
          '<div class="dba-sticky-atc__price">' + priceText + '</div>' +
          '<div class="dba-sticky-atc__inst">or as low as US$28/mo</div>' +
        '</div>' +
        '<button type="button" class="dba-sticky-atc__btn dba-cta-primary">Add to cart</button>' +
      '</div>';
    document.body.appendChild(bar);

    // Show only after scrolling past the in-page ATC — observe its position
    var mainAtc = document.querySelector('.add-to-cart-button, .product-form__buttons, [data-product-form] button[type="submit"]');
    if (mainAtc) {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          // Show sticky when main ATC is OUT of view
          bar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, { rootMargin: '-50px 0px 0px 0px', threshold: 0 });
      io.observe(mainAtc);
    } else {
      // No main ATC found — show after some scroll
      var onScroll = function(){
        bar.classList.toggle('is-visible', window.pageYOffset > 600);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    // Wire the sticky button → trigger the in-page ATC click (so all variant logic runs)
    bar.querySelector('.dba-sticky-atc__btn').addEventListener('click', function(e){
      e.preventDefault();
      var realBtn =
        document.querySelector('.add-to-cart-button') ||
        document.querySelector('product-form-component button[type="submit"]') ||
        document.querySelector('[data-product-form] button[type="submit"]') ||
        document.querySelector('form[action*="/cart/add"] button[type="submit"]');
      if (realBtn) realBtn.click();
    });
  }

  // Replace the OLD product 360 rotation GIFs with the latest transparent product image — runs on every page
  function swapProduct360Gifs(){
    var NEW_URL = 'https://cdn.shopify.com/s/files/1/0721/5287/5164/files/output_nobg_720.gif?v=1778513660';
    var oldUrlPatterns = [
      'video_square_nobg.gif',
      'video_square.gif',
      'dbakeraid_transparent.gif',
      'output_transparent.gif',
      'dbakeraid2_trimmed.png'
    ];
    document.querySelectorAll('img').forEach(function(img){
      var src = img.getAttribute('src') || '';
      for (var i = 0; i < oldUrlPatterns.length; i++) {
        if (src.indexOf(oldUrlPatterns[i]) > -1) {
          img.setAttribute('src', NEW_URL);
          img.setAttribute('alt', 'D’BakerAid Smart Scale');
          break;
        }
      }
    });
  }

  // Post-LOOX CTA banner — appears AFTER the LOOX reviews section
  function insertPostLooxCTA(){
    if (document.querySelector('.dba-post-loox-cta')) return;

    var looxSelectors = [
      '#looxReviews','#loox-reviews','#loox_reviews',
      '[data-loox-reviews]','[data-loox-id]',
      '.loox-reviews-default','.loox-rating','.loox',
      '[id*="loox" i]','[class*="loox" i]'
    ];
    var loox = null;
    for (var i = 0; i < looxSelectors.length && !loox; i++) {
      loox = document.querySelector(looxSelectors[i]);
    }
    var anchor = loox ? loox.closest('section, .shopify-section') || loox : null;
    if (!anchor) return; // only render if LOOX is found

    var section = document.createElement('section');
    section.className = 'dba-post-loox-cta';
    section.innerHTML =
      '<div class="dba-post-loox-cta__inner">' +
        '<span class="dba-post-loox-cta__eyebrow">Ready to bake?</span>' +
        '<h2 class="dba-post-loox-cta__h">Join 30,000+ home bakers who never <em>wait again</em></h2>' +
        '<p class="dba-post-loox-cta__sub">From yeast to oven-ready in 80 minutes. Every loaf, every time. 30-day money-back guarantee.</p>' +
        '<a class="dba-cta-primary" href="#shop" onclick="document.querySelector(\'.add-to-cart-button, .shopify-payment-button__button, .product-form\')?.scrollIntoView({behavior:\'smooth\',block:\'center\'});return false;">' +
          'Bring it home →' +
        '</a>' +
      '</div>';

    // Insert AFTER the LOOX section
    anchor.parentNode.insertBefore(section, anchor.nextSibling);
  }

  // Replace "Calculate Your Own Savings" CTA text on homepage Six+Math section
  function rewriteMathCta(){
    var ctas = document.querySelectorAll('a.dba-cta, .dba-sm .dba-cta, [class*="math__cta"], [class*="six-math"] a');
    ctas.forEach(function(a){
      var t = (a.textContent || '').trim();
      if (/Calculate\s+Your\s+Own\s+Savings/i.test(t)) {
        a.textContent = 'GET NOW AFTER THE MATH';
      }
    });
    // Also catch any other anchor anywhere on the page with that text
    var allAnchors = document.querySelectorAll('a');
    allAnchors.forEach(function(a){
      if (a.dataset.dbaCtaRewritten) return;
      if (a.children.length > 0) return;
      var t = (a.textContent || '').trim();
      if (/^Calculate\s+Your\s+Own\s+Savings/i.test(t)) {
        a.textContent = 'GET NOW AFTER THE MATH';
        a.dataset.dbaCtaRewritten = '1';
      }
    });
  }

  // Speed up the stats counters in the Science section (was 5s, make it ~1.2s).
  // Targets the 43 / 34 / 61% animations.
  function speedUpStatsCounters(){
    var heading = Array.from(document.querySelectorAll('h1, h2, h3')).find(function(h){
      return /Science\s+Behind\s+Every\s+Perfect\s+Loaf/i.test(h.textContent || '');
    });
    if (!heading) return;
    var section = heading.closest('section, .shopify-section');
    if (!section || section.dataset.dbaCounter) return;
    section.dataset.dbaCounter = '1';

    var targets = [43, 34, 61];
    // Find % number elements — Horizon may render them as <span data-counter> or similar.
    // Fall back to any element whose textContent is a digit / contains %
    var nodes = Array.from(section.querySelectorAll('*')).filter(function(el){
      if (el.children.length > 0) return false;
      var t = (el.textContent || '').trim();
      return /^\d{1,3}%?$/.test(t) || /^\d{1,3}\.?\d*%?$/.test(t);
    });

    // Match by current numeric value to known targets (43, 34, 61) — order may differ
    var byVal = {};
    nodes.forEach(function(n){
      var v = parseInt(n.textContent, 10);
      if (!isNaN(v) && targets.indexOf(v) > -1 && !byVal[v]) byVal[v] = n;
    });

    var found = Object.keys(byVal);
    if (!found.length) return;

    // Create an IntersectionObserver to start the animation when in view
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (!e.isIntersecting || e.target.dataset.dbaAnimated) return;
        e.target.dataset.dbaAnimated = '1';
        var target = parseInt(e.target.textContent, 10);
        if (isNaN(target)) return;
        // Reset to 0 and animate up over 1200ms
        var start = performance.now();
        var dur = 1200;
        var hasPercent = (e.target.textContent || '').indexOf('%') > -1;
        function step(now){
          var p = Math.min(1, (now - start) / dur);
          // ease-out-cubic
          var ease = 1 - Math.pow(1 - p, 3);
          var v = Math.round(target * ease);
          e.target.textContent = v + (hasPercent ? '%' : '');
          if (p < 1) requestAnimationFrame(step);
          else e.target.textContent = target + (hasPercent ? '%' : '');
        }
        // Start immediately
        e.target.textContent = '0' + (hasPercent ? '%' : '');
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });

    found.forEach(function(k){ io.observe(byVal[k]); });
  }

  // (removed in v12) — placeholder bonus card injection caused giant icons
  function addKitGridBonusCards_DISABLED(){
    var heading = Array.from(document.querySelectorAll('h1, h2, h3')).find(function(h){
      return /What\s+Comes\s+In\s+The\s+Full\s+Kit/i.test(h.textContent || '');
    });
    if (!heading) return;
    var section = heading.closest('section, .shopify-section, [class*="image-grid"]');
    if (!section || section.dataset.dbaKitBonus) return;
    section.dataset.dbaKitBonus = '1';

    // Find the grid container (where image cards live)
    var existingCards = section.querySelectorAll('img');
    if (!existingCards.length) return;
    var firstCard = existingCards[0].closest('a, figure, [class*="image-grid__item"], [class*="grid__item"], div');
    if (!firstCard) return;
    var grid = firstCard.parentElement;
    if (!grid) return;

    // Avoid duplicating
    if (grid.querySelector('[data-dba-bonus-card]')) return;

    var bonusCards = [
      {label:'80-Min Recipe Book', svg:'<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="10" y="6" width="44" height="52" rx="4" fill="#F5E6C8" stroke="#8B5218" stroke-width="2"/><line x1="10" y1="20" x2="54" y2="20" stroke="#8B5218" stroke-width="1.5"/><line x1="10" y1="30" x2="54" y2="30" stroke="#C9A84C" stroke-width="1.5"/><line x1="10" y1="40" x2="54" y2="40" stroke="#C9A84C" stroke-width="1.5"/><line x1="10" y1="50" x2="54" y2="50" stroke="#C9A84C" stroke-width="1.5"/><circle cx="32" cy="13" r="3.5" fill="#C56B3A"/></svg>'},
      {label:'BakeClip Free Access', svg:'<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="6" y="14" width="52" height="36" rx="6" fill="#1A1410"/><rect x="10" y="18" width="44" height="28" rx="3" fill="#3D2817"/><polygon points="26,24 26,40 40,32" fill="#C9A84C"/><circle cx="50" cy="50" r="8" fill="#2D5A3D" stroke="#FFFFFF" stroke-width="2"/><polyline points="46,50 49,53 54,47" stroke="#FFFFFF" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>'}
    ];

    bonusCards.forEach(function(card){
      var node = firstCard.cloneNode(true);
      node.setAttribute('data-dba-bonus-card', '1');

      // Replace the inner <img> with our placeholder SVG
      var img = node.querySelector('img');
      if (img) {
        var holder = document.createElement('div');
        holder.style.cssText = 'aspect-ratio:1/1;width:100%;background:#FAF7F2;border-radius:12px;display:flex;align-items:center;justify-content:center;padding:18%;';
        holder.innerHTML = card.svg;
        img.replaceWith(holder);
      }

      // Replace the caption text
      var caption = node.querySelector('[class*="caption"], figcaption, p');
      if (caption) caption.textContent = card.label;
      grid.appendChild(node);
    });
  }

  // #5 — ensure title shows D'BakerAid™ SureDough™ Complete Kit
  function fixTitleTm(){
    var titles = document.querySelectorAll('product-information h1, product-details-component h1, .product-details h1, .dba-pdp-title, h1.dba-pdp-title');
    titles.forEach(function(h1){
      if (!h1) return;
      var t = h1.textContent || '';
      // Add ™ after first "D'BakerAid" if missing
      if (/D[''']BakerAid(?!™)/.test(t)) {
        h1.innerHTML = h1.innerHTML.replace(/(D[''']BakerAid)(?!™)/, '$1™');
      }
    });
  }

  // #8 — append Recipe Book + BakeClip to Launch Kit, update count + total
  function upgradeLaunchKit(){
    var list = document.querySelector('.dba-breakdown__items');
    if (!list || list.dataset.dbaUpgraded) return;
    list.dataset.dbaUpgraded = '1';

    // Green checkmark — same as the paid items above (was gold)
    var checkSvg = '<svg class="dba-breakdown__check" viewBox="0 0 16 16" fill="none" aria-hidden="true"><circle cx="8" cy="8" r="8" fill="#2D5A3D"/><polyline points="4.5,8.5 7,11 11.5,6" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    var li1 = document.createElement('li');
    li1.className = 'dba-breakdown__item dba-breakdown__item--bonus';
    li1.innerHTML = checkSvg + '<span class="dba-breakdown__item-name">80-Min Recipe Book</span><span class="dba-breakdown__item-value">$20</span>';
    list.appendChild(li1);

    var li2 = document.createElement('li');
    li2.className = 'dba-breakdown__item dba-breakdown__item--bonus';
    li2.innerHTML = checkSvg + '<span class="dba-breakdown__item-name">BakeClip Free Access</span><span class="dba-breakdown__item-value">$25</span>';
    list.appendChild(li2);

    // Update count (7 → 9) and totals — Save $191 per Jesse's spec
    var count = document.querySelector('.dba-breakdown__count');
    if (count) count.textContent = '9 items included';
    var totalSub = document.querySelector('.dba-breakdown__total-sub');
    if (totalSub) totalSub.innerHTML = 'All 9 items for <s>$491+</s>';
    var savings = document.querySelector('.dba-breakdown__savings-badge');
    if (savings) savings.textContent = 'Save $191';

    // Make the kit collapsible — show only 2 items + total preview by default
    var breakdown = list.closest('.dba-breakdown');
    if (breakdown && !breakdown.dataset.dbaCollapsible) {
      breakdown.dataset.dbaCollapsible = '1';
      breakdown.classList.add('is-collapsed');

      var totalCount = list.querySelectorAll('li').length;
      var hidden = Math.max(0, totalCount - 2);

      // Expand toggle — placed between items list and total row
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'dba-breakdown__expand';
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-controls', 'dba-launch-kit-items');
      list.id = 'dba-launch-kit-items';
      btn.innerHTML =
        '<span class="dba-breakdown__expand-text" data-text-collapsed="View all ' + totalCount + ' items" data-text-expanded="Show fewer items">' +
          'View all ' + totalCount + ' items' +
        '</span>' +
        '<span class="dba-breakdown__expand-count" data-count-collapsed="(+' + hidden + ' more)">' +
          '(+' + hidden + ' more)' +
        '</span>' +
        '<svg class="dba-breakdown__expand-chevron" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<path d="M2 4l4 4 4-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>';

      // Insert button right after the items list
      list.parentNode.insertBefore(btn, list.nextSibling);

      btn.addEventListener('click', function(e){
        e.stopPropagation();
        var nowCollapsed = breakdown.classList.toggle('is-collapsed');
        btn.setAttribute('aria-expanded', nowCollapsed ? 'false' : 'true');
        var textEl = btn.querySelector('.dba-breakdown__expand-text');
        var countEl = btn.querySelector('.dba-breakdown__expand-count');
        if (textEl) {
          textEl.textContent = nowCollapsed
            ? textEl.dataset.textCollapsed
            : textEl.dataset.textExpanded;
        }
        if (countEl) {
          countEl.style.display = nowCollapsed ? '' : 'none';
        }
      });
    }
  }

  // #9 — insert hotline after the trust badges (.dba-badges). Non-clickable per Jesse's spec.
  function insertHotline(){
    if (document.querySelector('.dba-hotline')) return;
    var badges = document.querySelector('.dba-badges');
    if (!badges) return;

    var phoneSvg = '<svg viewBox="0 0 24 24"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.37 1.91.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.9.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    var d = document.createElement('div');
    d.className = 'dba-hotline';
    d.setAttribute('role', 'note');
    d.setAttribute('aria-label', '24-hour US hotline contact info');
    d.innerHTML =
      '<span class="dba-hotline__pulse" aria-hidden="true"></span>' +
      '<span class="dba-hotline__icon" aria-hidden="true">' + phoneSvg + '</span>' +
      '<span class="dba-hotline__body">' +
        '<span class="dba-hotline__label">24/7 US Hotline · Real Humans</span>' +
        '<span class="dba-hotline__number">+1 (507) 480-5710</span>' +
      '</span>';

    badges.parentNode.insertBefore(d, badges.nextSibling);
  }

  // ---------- v23 helpers ----------

  // 1) SEE HOW IT WORKS hero CTA → smooth scroll to the meals video section
  function seeHowItWorksScroll(){
    var anchors = Array.from(document.querySelectorAll('a, button'));
    anchors.forEach(function(el){
      var t = (el.textContent || '').trim();
      if (!/see\s+how\s+it\s+works/i.test(t)) return;
      if (el.dataset.dbaScrollWired) return;
      el.dataset.dbaScrollWired = '1';
      el.addEventListener('click', function(e){
        var target =
          document.querySelector('.dbam') ||
          document.querySelector('.dba-section') ||
          document.querySelector('[id*="custom_liquid_fmjRLA"]') ||
          document.querySelector('.custom-liquid');
        if (target) {
          e.preventDefault();
          target.scrollIntoView({behavior:'smooth',block:'start'});
        }
      });
    });
  }

  // 2-6) Header + social link rewrites
  function rewriteNavAndSocialLinks(){
    var rewrites = [
      // APP nav: rewrite https://dbakeraid.app → https://www.dbakeraid.app
      {match:function(href){ return /^https?:\/\/(www\.)?dbakeraid\.app\/?$/i.test(href); }, to:'https://www.dbakeraid.app'},
      // Facebook
      {match:function(href){ return /facebook\.com\/profile\.php\?id=61570132618464/i.test(href); }, to:'https://www.facebook.com/profile.php?id=61570132618464&locale=is_IS#'},
      // Instagram (any old variant)
      {match:function(href){ return /instagram\.com\/(duduoutmezgine|dbakeraid)/i.test(href); }, to:'https://www.instagram.com/dbakeraid/'},
      // YouTube
      {match:function(href){ return /youtube\.com\//i.test(href) && !/DBakerAidbyDMatrixLab/i.test(href); }, to:'https://www.youtube.com/@DBakerAidbyDMatrixLab'}
    ];
    document.querySelectorAll('a[href]').forEach(function(a){
      var h = a.getAttribute('href') || '';
      for (var i=0;i<rewrites.length;i++){
        if (rewrites[i].match(h)) { a.setAttribute('href', rewrites[i].to); break; }
      }
    });
  }

  // 4) Hotline copy: drop "Real Humans" wording
  function fixHotlineCopy(){
    var lab = document.querySelector('.dba-hotline__label');
    if (lab) lab.textContent = '24/7 Customer Support';
  }

  // 5) Footer-only SureDough™ → SureDough (we trademarked D'BakerAid only)
  function fixSureDoughTrademarkInFooter(){
    var footer = document.querySelector('footer, [class*="footer"]');
    if (!footer) return;
    walkText(footer, function(node){
      if (node.nodeValue && node.nodeValue.indexOf('SureDough™') > -1) {
        node.nodeValue = node.nodeValue.split('SureDough™').join('SureDough');
      }
    });
    function walkText(el, fn){
      var children = el.childNodes;
      for (var i=0;i<children.length;i++){
        var n = children[i];
        if (n.nodeType === Node.TEXT_NODE) fn(n);
        else if (n.nodeType === Node.ELEMENT_NODE) walkText(n, fn);
      }
    }
  }

  // 6) Instruction Manual link → dbakeraid.app/UserManual
  function rewriteInstructionManualLink(){
    document.querySelectorAll('a').forEach(function(a){
      var t = (a.textContent || '').trim();
      if (/^(instruction\s+manual|user\s+manual|manual)$/i.test(t)) {
        a.setAttribute('href', 'https://dbakeraid.app/UserManual');
        a.setAttribute('target', '_blank');
        a.setAttribute('rel', 'noopener');
      }
    });
  }

  // 7) Hide "Our Story" footer link
  function hideOurStoryFooter(){
    document.querySelectorAll('a').forEach(function(a){
      var t = (a.textContent || '').trim();
      if (/^our\s+story$/i.test(t)) {
        var li = a.closest('li');
        if (li) li.style.display = 'none';
        else a.style.display = 'none';
      }
    });
  }

  // 9) Founder signature — real Arik Moyal signature image (replaces founder photo + inline signature)
  function addFounderSignature(){
    var SIG_URL = 'https://cdn.shopify.com/s/files/1/0721/5287/5164/files/arik-moyal-signature.png?v=1778339827';
    var SIG_HTML =
      '<img class="dba-founder-signature-img" src="' + SIG_URL + '" ' +
        'alt="Arik Moyal — Founder, D’BakerAid">';

    // A) Theme's about-founder section: replace any IMG inside its image-wrap (the founder photo)
    document.querySelectorAll('[class*="about-founder-"][class*="__image-wrap"] img').forEach(function(img){
      var src = img.getAttribute('src') || '';
      if (src.indexOf('arik-moyal-signature') > -1) return;
      img.setAttribute('src', SIG_URL);
      img.setAttribute('alt', 'Arik Moyal — Founder, D’BakerAid');
      img.classList.add('dba-founder-signature-img');
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      // Strip inline width/height so our CSS sizing wins
      img.style.removeProperty('width');
      img.style.removeProperty('height');
    });

    // B) Theme's about-founder section: inline signature image under body text — also swap
    document.querySelectorAll('[class*="about-founder-"][class*="__signature"] img').forEach(function(img){
      var src = img.getAttribute('src') || '';
      if (src.indexOf('arik-moyal-signature') > -1) return;
      img.setAttribute('src', SIG_URL);
      img.setAttribute('alt', 'Arik Moyal signature');
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
    });

    // C) Theme's fallback path (when no founder image is set): swap fallback img too
    document.querySelectorAll('[class*="about-founder-"][class*="__signature-fallback"] img').forEach(function(img){
      var src = img.getAttribute('src') || '';
      if (src.indexOf('arik-moyal-signature.png') > -1) return; // already new
      img.setAttribute('src', SIG_URL);
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
    });

    // D) JS-injected signatures from earlier versions — upgrade or create fresh
    var existing = document.querySelector('.dba-founder-signature-wrap');
    if (existing) {
      if (!existing.querySelector('.dba-founder-signature-img')) {
        existing.innerHTML = SIG_HTML;
      }
    } else {
      // Look for an arbitrary founder photo elsewhere (PDP, other pages) and replace it
      var imgs = document.querySelectorAll('img');
      var founderImg = null;
      for (var i=0;i<imgs.length;i++){
        var img = imgs[i];
        // Skip imgs we've already touched in steps A-C
        if (img.closest('[class*="about-founder-"]')) continue;
        var alt = (img.getAttribute('alt') || '').toLowerCase();
        var src = (img.getAttribute('src') || '').toLowerCase();
        if (src.indexOf('arik-moyal-signature') > -1) continue;
        var ctx = ((img.closest('section, article, div') || {}).textContent || '').toLowerCase();
        if (/arik|moyal/i.test(alt + ' ' + src) || /founder/i.test(ctx.slice(0,200))) {
          founderImg = img;
          break;
        }
      }
      if (founderImg) {
        var wrap = document.createElement('div');
        wrap.className = 'dba-founder-signature-wrap';
        wrap.innerHTML = SIG_HTML;
        founderImg.replaceWith(wrap);
      }
    }
  }

  // Belt-and-braces: remove "Founder Signature" eyebrow text + "Arik Moyal — Founder" caption
  // that the theme's about-founder section renders alongside the signature
  function purgeOldSignatureArtifacts(){
    // Old JS-injected cursive nodes
    document.querySelectorAll('.dba-founder-signature-text, .dba-founder-signature-flourish').forEach(function(el){
      var w = el.closest('.dba-founder-signature-wrap');
      if (w && w.querySelector('.dba-founder-signature-img')) {
        el.remove();
      } else if (w) {
        w.innerHTML =
          '<img class="dba-founder-signature-img" ' +
            'src="https://cdn.shopify.com/s/files/1/0721/5287/5164/files/arik-moyal-signature.png?v=1778339827" ' +
            'alt="Arik Moyal — Founder, D’BakerAid">';
      } else {
        el.remove();
      }
    });
    // Theme's hardcoded labels
    document.querySelectorAll(
      '[class*="about-founder-"][class*="__signature-fallback-eyebrow"], ' +
      '[class*="about-founder-"][class*="__signature-fallback-name"], ' +
      '[class*="about-founder-"][class*="__name"]'
    ).forEach(function(el){ el.style.display = 'none'; });
    // Belt-and-braces: any text node that EXACTLY equals "Founder Signature" anywhere
    document.querySelectorAll('span, p, div, h1, h2, h3, h4, h5, h6').forEach(function(el){
      var t = (el.textContent || '').trim();
      if (t === 'Founder Signature' || t === 'FOUNDER SIGNATURE') {
        el.style.display = 'none';
      }
    });
  }

  // Footer +10 columns of useful links
  function addFooterExtraColumns(){
    if (document.querySelector('.dba-footer-extra')) return;
    var footer = document.querySelector('footer, [class*="footer"]');
    if (!footer) return;

    var section = document.createElement('div');
    section.className = 'dba-footer-extra';
    section.innerHTML =
      '<div class="dba-footer-extra__cols">' +
        '<div class="dba-footer-extra__col">' +
          '<h4>Bake Better</h4>' +
          '<ul>' +
            '<li><a href="/pages/recipes">Recipe Library</a></li>' +
            '<li><a href="/pages/the-science-behind-dbakeraid">The Science</a></li>' +
            '<li><a href="/pages/efficiency">Efficiency</a></li>' +
            '<li><a href="https://dbakeraid.app">Companion App</a></li>' +
            '<li><a href="https://dbakeraid.app/UserManual" target="_blank" rel="noopener">User Manual</a></li>' +
          '</ul>' +
        '</div>' +
        '<div class="dba-footer-extra__col">' +
          '<h4>Shop</h4>' +
          '<ul>' +
            '<li><a href="/products/dbakeraid-complete-kit">Complete Kit</a></li>' +
            '<li><a href="/collections/accessories">Accessories</a></li>' +
            '<li><a href="/products/megavalue-pack">Megavalue Pack</a></li>' +
            '<li><a href="/pages/gift-cards">Gift Cards</a></li>' +
          '</ul>' +
        '</div>' +
        '<div class="dba-footer-extra__col">' +
          '<h4>Programs</h4>' +
          '<ul>' +
            '<li><a href="/pages/affiliate">Affiliate Program</a></li>' +
            '<li><a href="/pages/become-a-partner">Become a Partner</a></li>' +
            '<li><a href="/pages/affiliate-dashboard">Affiliate Dashboard</a></li>' +
            '<li><a href="/pages/wholesale">Wholesale / B2B</a></li>' +
          '</ul>' +
        '</div>' +
        '<div class="dba-footer-extra__col">' +
          '<h4>About</h4>' +
          '<ul>' +
            '<li><a href="/pages/press">Press &amp; Media Kit</a></li>' +
            '<li><a href="/pages/careers">Careers</a></li>' +
            '<li><a href="/pages/sustainability">Sustainability</a></li>' +
            '<li><a href="/pages/accessibility">Accessibility</a></li>' +
          '</ul>' +
        '</div>' +
      '</div>';
    footer.parentNode.insertBefore(section, footer);
  }

  // ---------- New multi-tab Comparison (Manus FINAL spec) ----------
  function insertComparisonV2(){
    if (document.querySelector('.dba-cmpv2')) return;
    var anchor = findReviewsAnchor();
    if (!anchor) return;

    // D'BakerAid product hero — use the actual transparent product GIF
    var DBA_HERO_IMG = '<img src="https://cdn.shopify.com/s/files/1/0721/5287/5164/files/output_web.gif?v=1778519484" alt="D’BakerAid Smart Scale">';
    var DBA_THUMB_IMG = '<img src="https://cdn.shopify.com/s/files/1/0721/5287/5164/files/output_web.gif?v=1778519484" alt="D’BakerAid">';

    // REAL competitor product photos (Shopify CDN, uploaded May 2026)
    var THUMB_IMG = {
      'brod-taylor': '<img src="https://cdn.shopify.com/s/files/1/0721/5287/5164/files/brod-taylor-folding-proofer.jpg?v=1778336150" alt="Brod & Taylor folding proofer">',
      'goldie':      '<img src="https://cdn.shopify.com/s/files/1/0721/5287/5164/files/sourhouse-goldie.jpg?v=1778336150" alt="Sourhouse Goldie">',
      'cresteto':    '<img src="https://cdn.shopify.com/s/files/1/0721/5287/5164/files/crustello-smart-bowl.webp?v=1778336150" alt="Crustello smart bowl">',
      'cuisinart':   '<img src="https://cdn.shopify.com/s/files/1/0721/5287/5164/files/cuisinart-cbk-110.jpg?v=1778336150" alt="Cuisinart CBK-110 bread maker">',
      'zojirushi':   '<img src="https://cdn.shopify.com/s/files/1/0721/5287/5164/files/zojirushi-bb-pdc20.png?v=1778336150" alt="Zojirushi BB-PDC20">',
      'anova':       '<img src="https://cdn.shopify.com/s/files/1/0721/5287/5164/files/anova-precision-oven.png?v=1778336150" alt="Anova Precision Oven">'
    };

    var DBA_ROWS = {
      'Yeast activation programs':       '<strong>3 modes</strong> — wild starter, instant, fresh, active dry',
      'Dough-proofing programs':          '<strong>4 programs</strong> — calibrated by flour type',
      'Programs calibrated per yeast & flour': 'Yes — picks the right curve for each combination',
      'Built-in timer (programs end automatically)': 'Yes — pick program, walk away',
      'Time to bake-ready dough':         '<strong>80 min total</strong> · 35 yeast + 45 proof · any yeast, any flour',
      'Multi-dough capability':           'Sourdough · pizza · croissant · brioche · naan · donuts · GF',
      'Built-in digital scale':           'Yes — recipe updates as ingredients go in',
      'Smart monitoring + touchscreen':   'Yes — one-touch programs',
      'Bake step':                        'In your oven, with the included steamer',
      'SureDough™ Guarantee':             'Every loaf rises. Every loaf bakes. Or refund.'
    };
    var DBA_PRICE = '<strong>$299.95</strong> — full SureDough™ system';

    var COMPETITORS = {
      'brod-taylor': { name:'Brod & Taylor folding proofer', price:'$249 — device only',
        rows:{'Yeast activation programs':'None — set a temperature manually','Dough-proofing programs':'None — single static temperature','Programs calibrated per yeast & flour':'<strong>No</strong> — baker picks one temp for the whole bake','Built-in timer (programs end automatically)':'<strong>No</strong> — baker monitors manually','Time to bake-ready dough':'Holds temp; dough still ferments at biological speed (sourdough bulk: 4–8 hrs at 75–78°F)','Multi-dough capability':'Any (manual) — no programmed support','Built-in digital scale':'No','Smart monitoring + touchscreen':'Knob + temperature display','Bake step':'In your oven (separate)','SureDough™ Guarantee':'No guarantee'},
        note:'Both devices control temperature. Only D’BakerAid runs <em>programs</em> — the right curve for each yeast and flour type, with a built-in timer that ends the cycle automatically. Bulk fermentation in a folding proofer still takes 4–8 hours for sourdough at typical settings — D’BakerAid finishes the full cycle in 80 minutes.'},
      'goldie': { name:'Sourhouse Goldie (starter warmer)', price:'$120 — starter warmer only',
        rows:{'Yeast activation programs':'1 — single warming temperature for starter','Dough-proofing programs':'<strong>None</strong> — does not proof dough','Programs calibrated per yeast & flour':'<strong>No</strong> — single 75–82°F warming zone','Built-in timer (programs end automatically)':'No','Time to bake-ready dough':'Activates starter (saves ~1 hr); does not proof dough','Multi-dough capability':'<strong>Sourdough starter only</strong>','Built-in digital scale':'No','Smart monitoring + touchscreen':'On/off + 3-zone light indicator','Bake step':'Not applicable','SureDough™ Guarantee':'No guarantee'},
        note:'A starter warmer is a beautiful object that does one thing well — holds a starter at 75–82°F. The SureDough™ system handles that step <em>and</em> the dough-proofing step the warmer leaves to your kitchen counter.'},
      'cresteto': { name:'Crustello (smart sensor bowl)', price:'~$200 (Kickstarter pre-order)',
        rows:{'Yeast activation programs':'<strong>None</strong> — passive sensor only','Dough-proofing programs':'<strong>None</strong> — tracks rise, doesn’t run programs','Programs calibrated per yeast & flour':'No — AI predicts; doesn’t control','Built-in timer (programs end automatically)':'App alerts when dough doubles; doesn’t control fermentation','Time to bake-ready dough':'Sensor only — fermentation = your kitchen’s natural time','Multi-dough capability':'Tracks any dough — no automation','Built-in digital scale':'No','Smart monitoring + touchscreen':'App + Time-of-Flight bowl sensor (passive)','Bake step':'Not applicable','SureDough™ Guarantee':'No guarantee · Kickstarter — est. delivery March 2026'},
        note:'Crustello reports; D’BakerAid <em>runs</em>. Plus: D’BakerAid ships in 2 business days; Crustello’s estimated backer-delivery is March 2026.'},
      'cuisinart': { name:'Cuisinart bread maker', price:'$80–$130 — machine only',
        rows:{'Yeast activation programs':'None — yeast added directly','Dough-proofing programs':'1 fixed program (sandwich loaf cycle)','Programs calibrated per yeast & flour':'<strong>No</strong> — single internal cycle','Built-in timer (programs end automatically)':'Yes (machine-internal)','Time to bake-ready dough':'2–3.5 hr full cycle (bake included) · dough-only ~45 min','Multi-dough capability':'<strong>One rectangular sandwich loaf only</strong>','Built-in digital scale':'No','Smart monitoring + touchscreen':'Button panel only','Bake step':'Inside the machine — pale soft crust','SureDough™ Guarantee':'No fermentation guarantee'},
        note:'A bread machine bakes one rectangular loaf in soft uneven heat. D’BakerAid handles real fermentation — sourdough, pizza, croissant, brioche — then your real oven handles the bake.'},
      'zojirushi': { name:'Zojirushi bread maker (premium)', price:'$250–$350 — machine only',
        rows:{'Yeast activation programs':'None — yeast added directly','Dough-proofing programs':'Multiple cycles + Home Made custom course','Programs calibrated per yeast & flour':'Custom course possible (advanced); not pre-calibrated','Built-in timer (programs end automatically)':'Yes (machine-internal)','Time to bake-ready dough':'3.5–6 hr full cycle · dough-only ~45 min','Multi-dough capability':'<strong>Sandwich loaves only — no real artisan</strong>','Built-in digital scale':'No','Smart monitoring + touchscreen':'Button panel only','Bake step':'Inside the machine — pale soft crust','SureDough™ Guarantee':'No fermentation guarantee'},
        note:'Zojirushi makes the best bread machine on the market — and it’s still a bread machine. Real artisan bread requires real fermentation control, then a real oven for the bake.'},
      'anova': { name:'Anova Precision Oven', price:'$599 — multi-purpose oven',
        rows:{'Yeast activation programs':'None — manual proof temperature only','Dough-proofing programs':'Single proof mode (preset 60% steam)','Programs calibrated per yeast & flour':'<strong>No</strong> — single setting across all doughs','Built-in timer (programs end automatically)':'Yes (oven-level)','Time to bake-ready dough':'1–2 hr proof at 80–90°F (±5°F drift per owner reports)','Multi-dough capability':'Manual proofing across any flour','Built-in digital scale':'No','Smart monitoring + touchscreen':'Yes — but tuned for sous vide and roasting','Bake step':'Bakes in the same unit','SureDough™ Guarantee':'No fermentation guarantee'},
        note:'A multi-purpose oven costs twice as much and proofs dough at one manual temperature with ±5°F drift. A purpose-built fermentation system, by definition, doesn’t have that learning curve.'},
    'countertop': { name:'Countertop · manual proofing', price:'“$0” up front — paid in failed bakes',
      rows:{'Yeast activation programs':'None — guess the water temp by hand','Dough-proofing programs':'None — proofs at room temperature','Programs calibrated per yeast & flour':'<strong>No</strong> — the same room temp for every dough','Built-in timer (programs end automatically)':'<strong>No</strong> — you watch the clock and the dough','Time to bake-ready dough':'4–24 hrs — drifts ±4°F an hour with the room','Multi-dough capability':'Manual — results swing with season','Built-in digital scale':'No — separate scale','Smart monitoring + touchscreen':'No — eyeball it','Bake step':'In your oven, no steam','SureDough™ Guarantee':'None — a flop is wasted flour and hours'},
      note:'Costs nothing up front — but gives zero temperature control. Most kitchens swing ±4°F an hour, so results vary by season. D’BakerAid locks the schedule and finishes in 80 minutes.'}
    };
    var ORDER = ['brod-taylor','goldie','cresteto','cuisinart','zojirushi','anova','countertop'];
    var TAB_LABELS = {'brod-taylor':'Brod & Taylor','goldie':'Sourhouse Goldie','cresteto':'Crustello','cuisinart':'Cuisinart','zojirushi':'Zojirushi','anova':'Anova Precision Oven','countertop':'Countertop · no device'};

    var section = document.createElement('section');
    section.className = 'dba-cmpv2';
    section.innerHTML =
      '<div class="dba-cmpv2__container">' +
        '<div class="dba-cmpv2__intro">' +
          '<span class="dba-cmpv2__eyebrow">The SureDough™ system · Final comparison</span>' +
          '<h2 class="dba-cmpv2__h">D’BakerAid <em>vs.</em> every alternative.</h2>' +
          '<p class="dba-cmpv2__sub">The proofer that actually proofs — head-to-head against the six tools real bakers cross-shop. All competitor times verified against manufacturer documentation.</p>' +
          '<div class="dba-cmpv2__hero">' + DBA_HERO_IMG + '</div>' +
          '<p class="dba-cmpv2__verified">Sources: Brod &amp; Taylor product page, Sourhouse FAQ, Crustello.com, Cuisinart manuals, Zojirushi user guides, Anova Culinary documentation. Last verified May 2026.</p>' +
        '</div>' +
        '<h3 class="dba-cmpv2__h2">Other tools warm dough. D’BakerAid runs the schedule.</h3>' +
        '<p class="dba-cmpv2__h2-sub">Click any tab — D’BakerAid stays on the left. Every row is the same question, asked of every competitor.</p>' +
        '<div class="dba-cmpv2__tabs" role="tablist">' +
          ORDER.map(function(k){
            return '<button class="dba-cmpv2__tab" role="tab" data-cmp-key="' + k + '">' + TAB_LABELS[k] + '</button>';
          }).join('') +
        '</div>' +
        '<div class="dba-cmpv2__wrap">' +
          '<table class="dba-cmpv2__table">' +
            '<colgroup>' +
              '<col class="dba-cmpv2__col--feat">' +
              '<col class="dba-cmpv2__col--us">' +
              '<col class="dba-cmpv2__col--rival">' +
            '</colgroup>' +
            '<thead><tr>' +
              '<th></th>' +
              '<th class="is-us"><div class="dba-cmpv2__th-product"><span class="dba-cmpv2__thumb is-us">' + DBA_THUMB_IMG + '</span><span>D’BakerAid</span></div></th>' +
              '<th data-cmp-header></th>' +
            '</tr></thead>' +
            '<tbody data-cmp-body></tbody>' +
          '</table>' +
        '</div>' +
        '<p class="dba-cmpv2__price-note" data-cmp-note></p>' +
        '<div class="dba-cmpv2__cta-strip">' +
          '<h3 class="dba-cmpv2__cta-h">30 days. Money-back guarantee.</h3>' +
          '<p class="dba-cmpv2__cta-p">Bake with D’BakerAid for 30 days. If the bread isn’t better, the schedule isn’t easier, or the device doesn’t earn its place on the counter — return it with our prepaid label. Only $24.95 return transportation is deducted from your refund — no restocking fee.</p>' +
          '<div class="dba-cmpv2__cta-price">$299.95</div>' +
          '<div class="dba-cmpv2__cta-price-sub">Free US shipping · Ships in 2 business days</div>' +
          '<a href="/products/dbakeraid-complete-kit" class="dba-cta-primary">Start Baking</a>' +
          '<div class="dba-installment-text" style="justify-content:center;margin-top:14px;">or <strong>4 payments of $74.99</strong> — interest-free with <span class="dba-installment-text__sp"></span></div>' +
          '<div class="dba-cmpv2__cta-guarantees">' +
            '<span><span class="dba-cmpv2__cta-star">★ 4.7</span> · 910 verified reviews</span>' +
            '<span>·</span><span>30-day money-back</span>' +
            '<span>·</span><span>2-year warranty</span>' +
            '<span>·</span><span>SureDough™ Guarantee</span>' +
          '</div>' +
        '</div>' +
      '</div>';

    if (anchor.id === 'MainContent' || anchor.tagName === 'MAIN') anchor.appendChild(section);
    else anchor.parentNode.insertBefore(section, anchor);

    function escAttr(s){ return String(s).replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/'/g,'&#39;'); }
    function loadCompetitor(key){
      var c = COMPETITORS[key];
      if (!c) return;
      var rivalName = TAB_LABELS[key] || c.name || 'Competitor';
      section.querySelector('[data-cmp-header]').innerHTML =
        '<div class="dba-cmpv2__th-product"><span class="dba-cmpv2__thumb">' + (THUMB_IMG[key] || '') + '</span><span>' + c.name + '</span></div>';
      var body = section.querySelector('[data-cmp-body]');
      body.innerHTML = '';
      Object.keys(DBA_ROWS).forEach(function(rk){
        var tr = document.createElement('tr');
        var rowSlug = rk.toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/(^-|-$)/g,'');
        tr.setAttribute('data-cmp-row', rowSlug);
        // data-rival-name on the competitor cell powers the mobile card pseudo-heading
        tr.innerHTML =
          '<td class="is-label">' + rk + '</td>' +
          '<td class="is-us">' + DBA_ROWS[rk] + '</td>' +
          '<td data-rival-name="' + escAttr(rivalName) + '">' + (c.rows[rk] || '—') + '</td>';
        body.appendChild(tr);
      });
      var pr = document.createElement('tr');
      pr.className = 'dba-cmpv2__price-row';
      pr.setAttribute('data-cmp-row', 'price');
      pr.innerHTML =
        '<td class="is-label">Price</td>' +
        '<td class="is-us">' + DBA_PRICE + '</td>' +
        '<td data-rival-name="' + escAttr(rivalName) + '">' + c.price + '</td>';
      body.appendChild(pr);
      section.querySelector('[data-cmp-note]').innerHTML = c.note;
      section.querySelectorAll('.dba-cmpv2__tab').forEach(function(t){
        t.classList.toggle('is-active', t.dataset.cmpKey === key);
      });
    }
    section.querySelectorAll('.dba-cmpv2__tab').forEach(function(t){
      // Use both click and touchend for reliable mobile activation
      var handler = function(e){ e.preventDefault(); loadCompetitor(t.dataset.cmpKey); };
      t.addEventListener('click', handler);
    });
    loadCompetitor('brod-taylor');
  }

  // Replace existing FAQ accordion with a 45-question, topic-grouped dropdown structure
  function insertFAQ45(){
    if (document.querySelector('.dba-faq45')) return;
    // Find the original FAQ section by heading
    var heading = Array.from(document.querySelectorAll('h1, h2, h3')).find(function(h){
      return /Frequently\s+Asked/i.test(h.textContent || '');
    });
    if (!heading) return;
    var oldSection = heading.closest('section, .shopify-section');
    if (!oldSection) return;

    var topics = [
      {name:'Product Basics', qs:[
        ['What exactly is D’BakerAid?','It’s a precision fermentation and proofing device — not a bread machine. It controls temperature and humidity through the two stages where they decide everything: yeast activation and dough proofing. You still mix, shape, and bake.'],
        ['Is this a bread machine?','No. Bread machines mix and bake for you. D’BakerAid only manages fermentation and proofing — your hands and your oven do the rest.'],
        ['What size is it?','14" × 12" × 10" (L × W × H), 8.5 lbs. Fits comfortably on a kitchen counter.'],
        ['How loud is it?','Near-silent operation. Typical readings are below 30 dB during normal use.'],
        ['Does it use a lot of electricity?','About 0.18 kWh per cycle — roughly the cost of a 2-minute toaster run. Far less than warming dough in an oven.']
      ]},
      {name:'How It Works', qs:[
        ['What does the SureDough system actually do?','Two stages: a yeast activation cycle (35 min) and a dough proofing cycle (45 min). Each holds temperature within ±0.5°C and adjusts humidity to match the recipe.'],
        ['Why does precision matter?','Most home kitchens drift 2–4°C across a four-hour proof. That swing is why sourdough collapses, dough goes flat, or bread comes out dense. Holding the line eliminates the variable.'],
        ['What is D’Steamer?','A small steam injector that attaches to your oven wall. It generates 82–88% humidity in the first minutes of baking — that’s where oven spring comes from.'],
        ['Do I need both the proofer and the steamer?','For everything fermentation-related, the proofer is what you need. The steamer is what makes the crust thin, glossy, and crackly. The kit includes both.'],
        ['Can I use my own programs?','Yes — manual mode lets you set any temperature within range and run any duration.'],
        ['Does it have an app?','Yes — the BakeClip companion app gives you scheduling, recipe scaling, and hydration tracking. Free with purchase.']
      ]},
      {name:'Recipes & Compatibility', qs:[
        ['Which recipes work with D’BakerAid?','Almost any dough that ferments — sourdough, pizza, focaccia, brioche, croissants, ciabatta, baguettes, naan, donuts, gluten-free, whole-grain. Tempering chocolate too.'],
        ['Does it work for sourdough specifically?','Yes — and it’s the area where it shines most. The dedicated sourdough program runs at 27–29°C, which is precisely where wild yeast and lactic acid balance correctly.'],
        ['Can I scale recipes up or down?','Up to 2 kg of dough per cycle — about 4 standard loaves. Single-loaf recipes work the same.'],
        ['Will my existing recipes still work?','Yes. D’BakerAid never touches your recipe, ingredients, or method. It just controls the conditions.'],
        ['Does it work with gluten-free?','Yes — there’s a calibrated program for gluten-free dough chemistry, which behaves differently than wheat.'],
        ['What about whole-grain or rye?','Yes. The four proofing programs are calibrated for white, mixed-grain, whole-grain, and sourdough flours.']
      ]},
      {name:'Setup & Use', qs:[
        ['Is it hard to set up?','No setup required — plug in, pick a program, press start. The 3-inch touchscreen walks you through it.'],
        ['Do I need baking experience?','Not at all. The 80-Min Recipe Book included with the kit is designed for first-time bakers.'],
        ['How long is a typical cycle?','35 minutes for yeast activation, 45 minutes for dough proofing — 80 minutes total of hands-off time. You’re not standing over it.'],
        ['Can I run multiple programs back-to-back?','Yes — start the next cycle as soon as one finishes.'],
        ['Does it remember my settings?','Yes — your last 5 programs are remembered, and the app syncs your full history.']
      ]},
      {name:'Cleaning & Care', qs:[
        ['How do I clean it?','Tritan bowls and lids are dishwasher-safe. Stainless steel bowl is hand-wash or dishwasher. Wipe the unit with a damp cloth.'],
        ['Are the bowls food-safe?','Yes — Tritan is BPA-free and rated for food contact. Stainless is 18/10 food-grade.'],
        ['How long do the parts last?','Designed for a decade-plus of normal home use. Replacement parts are available through customer support.']
      ]},
      {name:'Shipping & Returns', qs:[
        ['Where do you ship?','Free standard shipping to the continental United States (3–7 business days). Hawaii, Alaska, Puerto Rico, Guam, and Canada available with surcharge.'],
        ['How fast does it ship?','Orders ship within 1–2 business days after payment confirmation.'],
        ['Can I return it if I don’t love it?','Yes — 30-day money-back guarantee. We email a prepaid return label; only $24.95 return transportation is deducted. No restocking fee.'],
        ['Who pays return shipping?','We send a prepaid label — $24.95 is deducted from the refund for return transportation. Defective or incorrect items ship free, both ways.'],
        ['Can I cancel my order?','Yes, before it ships. Email c.care@dbakeraid.com within 24 hours.']
      ]},
      {name:'Warranty & Support', qs:[
        ['What’s the warranty?','2-year limited warranty against manufacturing defects and malfunctions under normal use.'],
        ['Where is it made?','Designed in the USA. Engineered in Germany. Assembled in China.'],
        ['How do I get help?','Email c.care@dbakeraid.com or use the 24/7 voicebot on the contact page.'],
        ['Are software updates free?','Yes — the device receives free firmware updates over WiFi for the life of the product.']
      ]},
      {name:'Apps & Software', qs:[
        ['What does the BakeClip app do?','Recipe scaling, hydration calculator, schedule planner, troubleshooting, and a growing library of community recipes.'],
        ['Does the app cost extra?','No — included free with every D’BakerAid Complete Kit purchase.'],
        ['Which platforms?','iOS and Android. The web app at dbakeraid.app works on any browser.']
      ]},
      {name:'Pricing & Value', qs:[
        ['Why does it cost $299.95?','It’s a precision instrument — temperature stability within ±0.5°C across hours, with a 2-year warranty. The Launch Kit value adds up to $491+.'],
        ['How fast does it pay for itself?','At an average $8 bakery loaf vs $0.79 at home, payback is roughly 38 loaves — about 5–8 weeks of regular baking for most households.'],
        ['Are there discounts available?','Sign up for the newsletter for occasional offers. Bulk and wholesale pricing available — contact us.']
      ]}
    ];

    var section = document.createElement('section');
    section.className = 'dba-faq45';
    var html =
      '<div class="dba-faq45__inner">' +
        '<div class="dba-faq45__head">' +
          '<span class="dba-faq45__eyebrow">Frequently asked questions</span>' +
          '<h2 class="dba-faq45__h">45 answers, organised by topic</h2>' +
        '</div>';
    topics.forEach(function(t){
      html += '<div class="dba-faq45__topic">' +
        '<button class="dba-faq45__topic-toggle" type="button" aria-expanded="false">' +
          '<span>' + t.name + '</span>' +
          '<span class="dba-faq45__topic-count">' + t.qs.length + ' Qs</span>' +
          '<svg class="dba-faq45__topic-chev" viewBox="0 0 16 16" fill="none"><path d="M3 6l5 5 5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</button>' +
        '<div class="dba-faq45__qa">' +
          t.qs.map(function(qa){
            return '<div class="dba-faq45__row">' +
              '<button class="dba-faq45__q" type="button" aria-expanded="false">' +
                '<span>' + qa[0] + '</span>' +
                '<span class="dba-faq45__q-plus">+</span>' +
              '</button>' +
              '<div class="dba-faq45__a">' + qa[1] + '</div>' +
            '</div>';
          }).join('') +
        '</div>' +
      '</div>';
    });
    html += '</div>';
    section.innerHTML = html;

    // Replace the original FAQ accordion section
    oldSection.parentNode.insertBefore(section, oldSection);
    oldSection.style.display = 'none';

    // Wire topic toggles (click to open/close — sole controller, no native details)
    section.querySelectorAll('.dba-faq45__topic-toggle').forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.preventDefault();
        var topic = btn.closest('.dba-faq45__topic');
        var open = topic.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    // Wire individual Q clicks
    section.querySelectorAll('.dba-faq45__q').forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.preventDefault();
        var row = btn.closest('.dba-faq45__row');
        var open = row.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    // Preview-expand the first Q&A in each topic (so visitors see one answer immediately)
    section.querySelectorAll('.dba-faq45__topic').forEach(function(topic){
      var firstRow = topic.querySelector('.dba-faq45__row');
      if (firstRow) {
        firstRow.classList.add('is-open');
        var firstQ = firstRow.querySelector('.dba-faq45__q');
        if (firstQ) firstQ.setAttribute('aria-expanded', 'true');
      }
    });
  }

  // Legacy simple 3-column comparison table (kept as fallback; not currently called)
  function insertComparisonTable(){
    if (document.querySelector('.dba-cmp-mfx')) return;
    var anchor = findReviewsAnchor();
    if (!anchor) return;

    var rows = [
      {feat:'Temperature Precision', simple:'How accurately it controls heat',  hero:'±1°C precision',   alt1:'±3–5°C drift',   alt2:'No control'},
      {feat:'Fermentation Modes',     simple:'How many bread types it handles', hero:'7 auto programs',   alt1:'Manual only',    alt2:'1 fixed program'},
      {feat:'Steam Control',          simple:'Keeps crust professional',         hero:'D’Steamer: 82–88%', alt1:'None',           alt2:'None'},
      {feat:'Bread Types',            simple:'What you can bake',                hero:'Any recipe',         alt1:'Any (inconsistent)', alt2:'1 rectangular loaf'},
      {feat:'Science-Backed Results', simple:'Lab-verified claims',              hero:'Published lab data', alt1:'No',             alt2:'No'},
      {feat:'Active Time Required',   simple:'How much you watch it',            hero:'~5 minutes',         alt1:'3–6 hours',      alt2:'3–4 hours'},
      {feat:'Worldwide Patent',       simple:'Unique, protected technology',     hero:'SureDough™ System',  alt1:'No',             alt2:'No'}
    ];

    var section = document.createElement('section');
    section.className = 'dba-cmp-mfx';
    section.setAttribute('aria-label', 'Comparison: D’BakerAid vs alternatives');

    var html =
      '<div class="dba-cmp-mfx__inner">' +
        '<div class="dba-cmp-mfx__head">' +
          '<span class="dba-cmp-mfx__eyebrow">How It Compares</span>' +
          '<h2 class="dba-cmp-mfx__h">We don’t trap you into <em>one loaf shape</em></h2>' +
          '<p class="dba-cmp-mfx__sub">Every bread machine in America makes the same rectangular loaf. D’BakerAid prepares real dough — then you bake whatever you want.</p>' +
        '</div>' +
        '<div class="dba-cmp-mfx__wrap">' +
          '<table>' +
            '<thead><tr>' +
              '<th class="dba-cmp-mfx__feature-h">Feature</th>' +
              '<th class="dba-cmp-mfx__hero-h">D’BakerAid™</th>' +
              '<th class="dba-cmp-mfx__alt-h">Folding Proofer</th>' +
              '<th class="dba-cmp-mfx__alt-h">Bread Machine</th>' +
            '</tr></thead>' +
            '<tbody>' +
              rows.map(function(r){
                return '<tr>' +
                  '<td class="dba-cmp-mfx__feature">' +
                    '<span class="dba-cmp-mfx__feature-name">' + r.feat + '</span>' +
                    '<span class="dba-cmp-mfx__feature-simple">' + r.simple + '</span>' +
                  '</td>' +
                  '<td class="dba-cmp-mfx__hero"><span class="dba-cmp-mfx__check">✓</span>' + r.hero + '</td>' +
                  '<td class="dba-cmp-mfx__alt">' + r.alt1 + '</td>' +
                  '<td class="dba-cmp-mfx__alt">' + r.alt2 + '</td>' +
                '</tr>';
              }).join('') +
            '</tbody>' +
          '</table>' +
        '</div>' +
      '</div>';
    section.innerHTML = html;

    if (anchor.id === 'MainContent' || anchor.tagName === 'MAIN') {
      anchor.appendChild(section);
    } else {
      anchor.parentNode.insertBefore(section, anchor);
    }
  }

  // Dudu Outmezgine testimonial card — Master Pastry Chef
  // Position: directly ABOVE The Baker's Launch Kit (per Manus design).
  // Photo: pulled from the homepage's video poster (same Dudu visual already on the site).
  function insertDuduTestimonial(){
    if (document.querySelector('.dba-dudu')) return;

    // Default avatar = poster from the homepage Dudu video. User can override via window.dbaDuduAvatarUrl.
    var avatarUrl = window.dbaDuduAvatarUrl ||
      'https://www.dbakeraid.com/cdn/shop/files/preview_images/2703a4fd85724a5f9a94fcaf37bf93df.thumbnail.0000000000_small.jpg?v=1772795098';

    var card = document.createElement('div');
    card.className = 'dba-dudu';
    card.innerHTML =
      '<div class="dba-dudu__avatar" aria-hidden="true">' +
        '<img src="' + avatarUrl + '" alt="Dudu Outmezgine" loading="lazy">' +
      '</div>' +
      '<div class="dba-dudu__body">' +
        '<p class="dba-dudu__quote">' +
          '"D’BakerAid™ is the tool I never knew I was missing. The precision it brings to fermentation and proofing is exactly what every serious baker needs."' +
        '</p>' +
        '<p class="dba-dudu__attribution">Dudu Outmezgine — Master Pastry Chef · 1.1M Followers · 30+ Years</p>' +
      '</div>';

    // Position directly ABOVE The Baker's Launch Kit (.dba-breakdown).
    var breakdown = document.querySelector('.dba-breakdown');
    if (breakdown) {
      breakdown.parentNode.insertBefore(card, breakdown);
      return;
    }
    // Fallback to general anchor if Launch Kit not found
    var anchor = findReviewsAnchor();
    if (!anchor) return;
    if (anchor.id === 'MainContent' || anchor.tagName === 'MAIN') {
      anchor.appendChild(card);
    } else {
      anchor.parentNode.insertBefore(card, anchor);
    }
  }

  // Shared anchor lookup for Dudu / 4-card testimonials / comparison table —
  // try LOOX, FAQ, last shopify-section, then MainContent.
  function findReviewsAnchor(){
    // v63: PAGE-AWARE ROUTING
    var path = (window.location.pathname || '/').replace(/\/$/, '');
    // SCIENCE + EFFICIENCY: skip social-proof injection entirely
    if (/^\/pages\/(the-science-behind-dbakeraid|efficiency)$/i.test(path)) return null;
    // SHIPPING + RETURNS/WARRANTY + similar policy pages: append at bottom of MainContent
    if (/^\/pages\/(shipping-policy|returns-warranty-policy|privacy-policy|terms-of-service|refund-policy)$/i.test(path)) {
      return document.getElementById('MainContent') || document.querySelector('main');
    }

    var looxSelectors = [
      '#looxReviews','#loox-reviews','#loox_reviews',
      '[data-loox-reviews]','[data-loox-id]',
      '.loox-reviews-default','.loox-rating','.loox',
      '[id*="loox" i]','[class*="loox" i]'
    ];
    var loox = null;
    for (var i = 0; i < looxSelectors.length && !loox; i++) {
      loox = document.querySelector(looxSelectors[i]);
    }
    var anchor = loox ? loox.closest('section, .shopify-section') || loox : null;
    if (!anchor) {
      var faq = Array.from(document.querySelectorAll('h1, h2, h3')).find(function(h){
        return /frequently\s+asked|FAQ\b/i.test(h.textContent || '');
      });
      anchor = faq ? faq.closest('section, .shopify-section') : null;
    }
    if (!anchor) {
      var sections = document.querySelectorAll('#MainContent .shopify-section, main .shopify-section, .content-for-layout .shopify-section');
      // v63: if there's only ONE content section and we don't have a better anchor, append at end of MainContent instead of inserting before the only section (which would put social-proof FIRST — wrong).
      if (sections.length > 1) anchor = sections[sections.length - 1];
    }
    if (!anchor) anchor = document.getElementById('MainContent') || document.querySelector('main');
    return anchor;
  }

  // #7 — insert 4 testimonials. Try LOOX first, then FAQ, then fall back to bottom of MainContent.
  function insertTestimonials(){
    if (document.querySelector('.dba-reviews')) return;
    var anchor = findReviewsAnchor();
    if (!anchor) return;

    var data = [
      {pain:"Sourdough was a 24-hour science project.", quote:"First time I got an open crumb on the FIRST attempt. The 27 °C window kept it from going sour like everything I baked in my apartment.", name:"Sarah M.", meta:"Brooklyn, NY · Beginner baker", grad:"linear-gradient(135deg,#C56B3A,#8B5218)", initials:"SM"},
      {pain:"I don’t have 12 hours to wait on dough.", quote:"80 minutes from yeast to oven-ready. I bake before work now. My 6 a.m. focaccia is better than the bakery on the corner.", name:"Marcus T.", meta:"Austin, TX · Working parent", grad:"linear-gradient(135deg,#185FA5,#0E3D6E)", initials:"MT"},
      {pain:"$8/loaf at the bakery was killing me.", quote:"38 loaves in and I’ve already paid this thing off. I’m baking twice a week — that’s $14 back in my pocket every week, forever.", name:"Jamie R.", meta:"Portland, OR · Budget-conscious", grad:"linear-gradient(135deg,#C9A84C,#8B5218)", initials:"JR"},
      {pain:"Store bread always bloated me.", quote:"The long fermentation in the sourdough program reduced the phytic acid for real — I can eat a whole slice of whole-wheat now and feel great. Doctor approved.", name:"Leah K.", meta:"Denver, CO · Gut-health focus", grad:"linear-gradient(135deg,#2D5A3D,#1B3A26)", initials:"LK"}
    ];

    var section = document.createElement('section');
    section.className = 'dba-reviews';
    section.setAttribute('aria-label', 'What real bakers are saying');
    var html = '<div class="dba-reviews__head">' +
      '<span class="dba-reviews__eyebrow">Real Bakers · Real Results</span>' +
      '<h2 class="dba-reviews__title">Pain points, gone. One bake at a time.</h2>' +
      '</div><div class="dba-reviews__grid">';
    data.forEach(function(r){
      html += '<article class="dba-review">' +
        '<div class="dba-review__pain">"' + r.pain + '"</div>' +
        '<p class="dba-review__quote">' + r.quote + '</p>' +
        '<div class="dba-review__author">' +
          '<div class="dba-review__avatar" style="background:' + r.grad + '">' + r.initials + '</div>' +
          '<div class="dba-review__meta"><strong>' + r.name + '</strong><span>' + r.meta + '</span></div>' +
          '<div class="dba-review__stars" aria-label="5 out of 5 stars">★★★★★</div>' +
        '</div>' +
      '</article>';
    });
    html += '</div>';
    section.innerHTML = html;

    // Insert BEFORE LOOX/FAQ section if found, otherwise APPEND to MainContent fallback
    if (anchor.id === 'MainContent' || anchor.tagName === 'MAIN') {
      anchor.appendChild(section);
    } else {
      anchor.parentNode.insertBefore(section, anchor);
    }
  }

  // Convert the static image on the LEFT of "Five Reasons Bakers Don't Look Back" into a slideshow.
  // User can replace placeholder slides by setting window.dbaFiveReasonsSlides = [{src:'...', caption:'...'}]
  function convertFiveReasonsToSlideshow(){
    var heading = Array.from(document.querySelectorAll('h2, h3')).find(function(h){
      return /Five Reasons Bakers/i.test(h.textContent || '');
    });
    if (!heading) return;
    var section = heading.closest('section, .shopify-section, [class*="ss-tabs"]');
    if (!section || section.dataset.dbaFrSlideshow) return;
    section.dataset.dbaFrSlideshow = '1';

    // Find the media container (image on the left)
    var mediaImg = section.querySelector('img');
    var mediaContainer = mediaImg ? mediaImg.closest('[class*="media"], [class*="image"], picture, figure, div') : null;
    if (!mediaContainer) return;

    // Slides — Jesse's 4 images in order. User can override via window.dbaFiveReasonsSlides.
    var slides = (window.dbaFiveReasonsSlides && window.dbaFiveReasonsSlides.length)
      ? window.dbaFiveReasonsSlides
      : [
          {src:'https://cdn.shopify.com/s/files/1/0721/5287/5164/files/1d047579-41f6-4308-81f2-19a48876abf7.jpg?v=1778318774'},
          {src:'https://cdn.shopify.com/s/files/1/0721/5287/5164/files/58816834-f85b-48d7-8317-2ce173134f59.jpg?v=1778318884'},
          {src:'https://cdn.shopify.com/s/files/1/0721/5287/5164/files/5644cc8e-189d-4482-a320-37b84c7c021e.jpg?v=1778319077'},
          {src:'https://cdn.shopify.com/s/files/1/0721/5287/5164/files/9c53020d-826d-4fe9-be04-a6eff2b6f481.jpg?v=1778318928'}
        ];

    // Build the slideshow HTML — no text labels
    var trackHtml = slides.map(function(s){
      var inner = s.src && s.caption
        ? '<div class="dba-fr-slideshow__caption">' + s.caption + '</div>'
        : '';
      var bg = s.src ? 'background-image:url(' + s.src + ');' : 'background:linear-gradient(135deg,#3D2817 0%,#1A1410 60%,#2B1B0F 100%);';
      return '<div class="dba-fr-slideshow__slide" style="' + bg + '">' + inner + '</div>';
    }).join('');

    var dotsHtml = slides.map(function(_, i){
      return '<button class="dba-fr-slideshow__dot' + (i === 0 ? ' is-active' : '') + '" data-slide-to="' + i + '" aria-label="Go to slide ' + (i+1) + '"></button>';
    }).join('');

    var wrap = document.createElement('div');
    wrap.className = 'dba-fr-slideshow';
    wrap.innerHTML =
      '<div class="dba-fr-slideshow__track" data-track style="width:' + (slides.length * 100) + '%">' + trackHtml + '</div>' +
      '<button class="dba-fr-slideshow__nav dba-fr-slideshow__nav--prev" data-prev aria-label="Previous slide">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><polyline points="15 18 9 12 15 6"/></svg>' +
      '</button>' +
      '<button class="dba-fr-slideshow__nav dba-fr-slideshow__nav--next" data-next aria-label="Next slide">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>' +
      '</button>' +
      '<div class="dba-fr-slideshow__dots" data-dots>' + dotsHtml + '</div>';

    // Track per-slide width: each slide is 100% of viewport (1/N of track width)
    var slideEls = wrap.querySelectorAll('.dba-fr-slideshow__slide');
    slideEls.forEach(function(s){ s.style.flex = '0 0 ' + (100 / slides.length) + '%'; });

    mediaContainer.replaceWith(wrap);

    // Slideshow logic
    var idx = 0;
    var track = wrap.querySelector('[data-track]');
    var dots = wrap.querySelectorAll('.dba-fr-slideshow__dot');
    function goTo(i){
      idx = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(' + (-idx * (100 / slides.length)) + '%)';
      dots.forEach(function(d, di){ d.classList.toggle('is-active', di === idx); });
    }
    wrap.querySelector('[data-prev]').addEventListener('click', function(){ goTo(idx - 1); pauseAuto(); });
    wrap.querySelector('[data-next]').addEventListener('click', function(){ goTo(idx + 1); pauseAuto(); });
    dots.forEach(function(d, di){ d.addEventListener('click', function(){ goTo(di); pauseAuto(); }); });

    // Auto-cycle every 4.5s, pause on hover/interaction
    var autoTimer = setInterval(function(){ goTo(idx + 1); }, 4500);
    function pauseAuto(){ clearInterval(autoTimer); }
    wrap.addEventListener('mouseenter', pauseAuto);
  }

  // Phase 5 — All-Day Meals 4-tab video switcher (latest Manus handoff). Single instance.
  function insertManusVideoSection(){
    // Hard-dedup: remove any leftover injections from prior versions
    var existing = document.querySelectorAll('.dba-pdp-manus-video, .dbam, .dba-section');
    if (existing.length > 1) {
      for (var i = 1; i < existing.length; i++) existing[i].remove();
    }
    if (document.querySelector('.dba-pdp-manus-video, .dbam')) return;

    // Position AFTER the "Five Reasons" section (lower in page)
    var heading = Array.from(document.querySelectorAll('h1, h2, h3')).find(function(h){
      return /Five\s+Reasons\s+Bakers/i.test(h.textContent || '');
    });
    if (!heading) {
      heading = Array.from(document.querySelectorAll('h1, h2, h3')).find(function(h){
        return /What\s+Comes\s+In\s+The\s+Full\s+Kit/i.test(h.textContent || '');
      });
    }
    if (!heading) return;
    var anchor = heading.closest('section, .shopify-section');
    if (!anchor) return;

    var meals = [
      { label: 'Breakfast', icon: '☀',     src: 'https://cdn.shopify.com/videos/c/o/v/d11a68a295e44c58b5554c6762ff6ee9.mp4' },
      { label: 'Lunch',     icon: '☕',     src: 'https://cdn.shopify.com/videos/c/o/v/d9ce695551e64aedbd57162d560f93d1.mp4' },
      { label: 'Dinner',    icon: '🌙', src: 'https://cdn.shopify.com/videos/c/o/v/89c38d45da1a46ef9fae5c26f2c281d4.mp4' },
      { label: 'Dessert',   icon: '🍰', src: 'https://cdn.shopify.com/videos/c/o/v/2b198059a77647a8a05035c61bc23a1b.mp4' }
    ];
    var nextLabels = ['Lunch', 'Dinner', 'Dessert', 'Breakfast'];

    var section = document.createElement('section');
    section.className = 'dbam dba-pdp-manus-video';
    section.innerHTML =
      '<div class="dbam-inner">' +
        '<div class="dbam-heading">' +
          '<span class="dbam-eyebrow">From Morning to Midnight</span>' +
          '<h2 class="dbam-headline">Every meal.<br>Made with love.</h2>' +
          '<p class="dbam-subtext">D’BakerAid is your kitchen companion from the first breakfast roll to the last dessert. Precision, warmth, and care in every measure.</p>' +
        '</div>' +
        '<div class="dbam-tabs" role="tablist">' +
          meals.map(function(m, i){
            return '<button class="dbam-tab' + (i === 0 ? ' active' : '') + '" role="tab" ' +
              'aria-selected="' + (i === 0 ? 'true' : 'false') + '" data-dbam-idx="' + i + '" id="dbam-tab-' + i + '" type="button">' +
                '<span class="dbam-tab-icon" aria-hidden="true">' + m.icon + '</span>' +
                '<span class="dbam-tab-label">' + m.label + '</span>' +
              '</button>';
          }).join('') +
        '</div>' +
        '<div class="dbam-frame-outer">' +
          '<div class="dbam-frame-gap">' +
            '<div class="dbam-frame-inner-line">' +
              '<div class="dbam-slider-viewport">' +
                '<div class="dbam-slider-track" data-dbam-track>' +
                  meals.map(function(m, i){
                    return '<div class="dbam-slide">' +
                      '<video src="' + m.src + '"' + (i === 0 ? ' autoplay' : '') + ' muted loop playsinline preload="' + (i === 0 ? 'auto' : 'metadata') + '"></video>' +
                    '</div>';
                  }).join('') +
                '</div>' +
                '<div class="dbam-peek-overlay" data-dbam-peek-overlay></div>' +
                '<div class="dbam-peek-label" data-dbam-peek-label>Lunch ›</div>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>' +
        cornerSvg('tl') + cornerSvg('tr') +
        '<div class="dbam-product-wrap">' +
          '<img src="https://cdn.shopify.com/s/files/1/0721/5287/5164/files/output_nobg_720.gif?v=1778513660" alt="D’BakerAid Smart Scale" loading="lazy">' +
        '</div>' +
        '<div class="dbam-cta-row">' +
          '<span class="dbam-cta-label">Bring D’BakerAid to every table →</span>' +
          '<a href="/products/dbakeraid-complete-kit" class="dbam-cta-link">Shop Now</a>' +
        '</div>' +
      '</div>';

    anchor.parentNode.insertBefore(section, anchor.nextSibling);

    // Wire tab switching
    var current = 0;
    var track = section.querySelector('[data-dbam-track]');
    var slides = track ? track.querySelectorAll('.dbam-slide') : [];
    var peekOverlay = section.querySelector('[data-dbam-peek-overlay]');
    var peekLabel = section.querySelector('[data-dbam-peek-label]');

    function dbamSwitch(index){
      if (index === current) return;
      current = index;
      track.style.transform = 'translateX(-' + (index * 25) + '%)';
      section.querySelectorAll('.dbam-tab').forEach(function(btn, i){
        btn.classList.toggle('active', i === index);
        btn.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      var isLast = index === meals.length - 1;
      if (peekOverlay) peekOverlay.style.display = isLast ? 'none' : '';
      if (peekLabel) {
        peekLabel.style.display = isLast ? 'none' : '';
        peekLabel.textContent = nextLabels[index] + ' ›';
      }
      slides.forEach(function(slide, i){
        var v = slide.querySelector('video');
        if (!v) return;
        if (i === index) v.play().catch(function(){});
        else v.pause();
      });
    }

    section.querySelectorAll('.dbam-tab').forEach(function(btn){
      btn.addEventListener('click', function(){
        dbamSwitch(parseInt(btn.dataset.dbamIdx, 10));
      });
    });

    // Auto-play first video
    var firstVid = slides[0] && slides[0].querySelector('video');
    if (firstVid) firstVid.play().catch(function(){});

    function cornerSvg(pos){
      return '<svg class="dbam-corner dbam-corner--' + pos + '" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M4 30 L4 4 L30 4" stroke="#c9a040" stroke-width="2.5" fill="none" stroke-linecap="square"/>' +
        '<rect x="2" y="2" width="5" height="5" fill="#c9a040"/>' +
      '</svg>';
    }
  }

  // #13 — auto-cycle "Bread" → "Pizza" → "Pastries" in the heading every 2 seconds.
  // No button row — just the word swaps with a smooth pop animation.
  function addRecipeSwitcher(){
    var heading = Array.from(document.querySelectorAll('h1, h2, h3')).find(function(h){
      return /Perfect\s+Bread\s+in\s+3\s+Simple/i.test(h.textContent || '');
    });
    if (!heading || heading.dataset.dbaSwitcher) return;
    heading.dataset.dbaSwitcher = '1';

    // Remove any older button row from previous v6/v7/v9 deploys
    var oldSwitcher = heading.parentNode.querySelector('.dba-recipe-switcher');
    if (oldSwitcher) oldSwitcher.remove();

    // Wrap the word "Bread" in a span so we can swap it out
    heading.innerHTML = heading.innerHTML.replace(
      /\b(Bread)\b/i,
      '<span class="dba-recipe-word" data-recipe-word>$1</span>'
    );

    var word = heading.querySelector('[data-recipe-word]');
    if (!word) return;

    var words = ['Bread', 'Pizza', 'Pastries'];
    var idx = 0;

    function tick(){
      idx = (idx + 1) % words.length;
      word.textContent = words[idx];
      // Re-trigger pop animation
      word.style.animation = 'none';
      // eslint-disable-next-line no-unused-expressions
      word.offsetHeight;
      word.style.animation = '';
    }

    setInterval(tick, 2000);
  }

  // #17 — flip cards on "What Comes In The Full Kit"
  // Lookup uses POSITIONAL INDEX (the 6 grid items render in a known fixed order).
  // Order: Smart Hub, D'Steamer, Tritan Bowls, Stainless Bowl, Danish Whisk + Bread Lame, Aprons.
  // User can override the array via window.dbaKitBackImagesByIndex.
  function enableKitFlipCards(){
    var heading = Array.from(document.querySelectorAll('h2, h3')).find(function(h){
      return /What\s+Comes\s+In\s+The\s+Full\s+Kit/i.test(h.textContent || '');
    });
    if (!heading) return;
    var section = heading.closest('section, .shopify-section, [class*="image-grid"]');
    if (!section || section.dataset.dbaFlip) return;
    section.dataset.dbaFlip = '1';

    var imgs = section.querySelectorAll('img');
    if (!imgs.length) return;

    // Filter out any images that are inside thumbnail / nav / non-grid wrappers
    var realImgs = Array.prototype.filter.call(imgs, function(img){
      return !img.closest('.dba-flipcard, [class*="thumbnail"], product-media-gallery, .product-media-gallery, header, nav');
    });

    var defaultBacks = window.dbaKitBackImagesByIndex || [
      'https://cdn.shopify.com/s/files/1/0721/5287/5164/files/proofed_dough.png?v=1777636994',                  // 0 Smart Hub
      'https://cdn.shopify.com/s/files/1/0721/5287/5164/files/D_Steamer.jpg?v=1772098331',                     // 1 D'Steamer
      'https://cdn.shopify.com/s/files/1/0721/5287/5164/files/FULL_YEAST_ACTIVATION.jpg?v=1774531229',         // 2 Tritan Bowls
      'https://cdn.shopify.com/s/files/1/0721/5287/5164/files/bread-result_1.jpg?v=1772098331',                // 3 Stainless Steel Bowl
      'https://cdn.shopify.com/s/files/1/0721/5287/5164/files/Generated_Image_May_08_2026_-_5_16PM.jpg?v=1778231823', // 4 Danish Whisk + Bread Lame
      'https://cdn.shopify.com/s/files/1/0721/5287/5164/files/h_Front_1.jpg?v=1778230653'                      // 5 Aprons
    ];

    var iconSvg = '<svg class="dba-flipcard__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M9 9h.01M15 9h.01M9 14s1.5 2 3 2 3-2 3-2"/></svg>';

    realImgs.forEach(function(img, idx){
      // Find the per-card caption near THIS image (look in img's parent or its siblings)
      var card = img.closest('a, figure, [class*="image-grid__item"], [class*="grid__item"], [class*="image-grid__cell"]') || img.parentElement;
      var labelEl =
        (card && card.querySelector && card.querySelector('[class*="caption"], figcaption, p, [class*="title"]')) ||
        (img.parentElement && img.parentElement.nextElementSibling) ||
        null;
      var label = (labelEl && labelEl.textContent ? labelEl.textContent : ('Kit item ' + (idx + 1))).trim();

      var backSrc = defaultBacks[idx] || '';

      // Build front face
      var frontFaceImg = img.cloneNode(true);
      frontFaceImg.removeAttribute('width');
      frontFaceImg.removeAttribute('height');

      var backFaceHtml = backSrc
        ? '<img src="' + backSrc + '" alt="' + label.replace(/"/g, '&quot;') + ' in use" loading="lazy" style="width:100%;height:100%;object-fit:cover;display:block;">'
        : iconSvg +
          '<div class="dba-flipcard__placeholder-title">' + label + '</div>' +
          '<div class="dba-flipcard__placeholder-sub">Add usage photo</div>';

      var wrap = document.createElement('div');
      wrap.className = 'dba-flipcard';
      wrap.tabIndex = 0;
      wrap.setAttribute('role', 'button');
      wrap.setAttribute('aria-label', label + ' — flip for usage photo');
      wrap.innerHTML =
        '<div class="dba-flipcard__inner">' +
          '<div class="dba-flipcard__face dba-flipcard__face--front"></div>' +
          '<div class="dba-flipcard__face dba-flipcard__face--back">' + backFaceHtml + '</div>' +
        '</div>';
      wrap.querySelector('.dba-flipcard__face--front').appendChild(frontFaceImg);

      img.replaceWith(wrap);

      // Tap-to-flip on touch devices
      wrap.addEventListener('click', function(){
        if (matchMedia('(hover: none)').matches) wrap.classList.toggle('is-flipped');
      });
      wrap.addEventListener('keydown', function(e){
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); wrap.classList.toggle('is-flipped'); }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {once:true});
  } else {
    init();
  }
})();

;
